/*
  Chronos Lights chatbot - Stage 6 (page awareness, knowledge base, product help, offers, cart assist, lead capture, team fallback)
  Save as: assets/cl-chatbot.js
  Rule-based, no AI. Later stages plug into CL.flows / CL.handleText.
*/
(function () {
  'use strict';
  if (window.__clcbInit) return;   // safety: never start twice if the section exists twice
  window.__clcbInit = true;
  var CFG = window.CLCB_CONFIG || {};

  /* ------------------------------------------------------------------
     LEAD SAVING: paste your two values here if the theme-editor settings
     are empty. Theme-editor values win when both are filled in.
     ------------------------------------------------------------------ */
  var FALLBACK = {
    leadEndpoint: 'https://script.google.com/macros/s/AKfycbxfOMo2Gv9dpTYhxUmJACrcncd_FSHZ5jFjFV37A9SqrTeDeJlQxvroAE3Um6jA2a2ROg/exec ',   // Apps Script Web app URL, ends with /exec
    leadToken: 'ALONGRANDOMSTRING'       // the same TOKEN you set in Code.gs
  };
  if (!CFG.leadEndpoint) CFG.leadEndpoint = FALLBACK.leadEndpoint;
  if (!CFG.leadToken) CFG.leadToken = FALLBACK.leadToken;
  var PAGE = CFG.page || {};
  var root = document.getElementById('clcb-root');
  if (!root) return;

  /* ---------- helpers ---------- */
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(paise) {
    return '₹' + Math.round(paise / 100).toLocaleString('en-IN');
  }
  function safe(fn) { try { return fn(); } catch (e) { return null; } }

  /* ---------- UI ---------- */
  var launcher = el('button', 'clcb-launcher',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2C6.5 2 2 5.9 2 10.8c0 2.6 1.3 4.9 3.4 6.5L4.5 22l4.6-2.4c.9.2 1.9.4 2.9.4 5.5 0 10-3.9 10-8.8S17.5 2 12 2z"/></svg>');
  launcher.setAttribute('aria-label', 'Open chat');
  if (CFG.launcherLabel) launcher.appendChild(el('span', 'clcb-label', esc(CFG.launcherLabel)));
  var badge = el('span', 'clcb-badge', '1');
  launcher.appendChild(badge);

  var win = el('div', 'clcb-window');
  win.setAttribute('role', 'dialog');
  win.setAttribute('aria-label', 'Chronos chat assistant');

  var header = el('div', 'clcb-header');
  var ht = el('div');
  ht.appendChild(el('div', 'clcb-title', 'Chronos Assistant'));
  ht.appendChild(el('div', 'clcb-sub', 'Ask about products, offers & orders'));
  var closeBtn = el('button', 'clcb-close', '&times;');
  closeBtn.setAttribute('aria-label', 'Close chat');
  header.appendChild(ht);
  header.appendChild(closeBtn);

  var body = el('div', 'clcb-body');

  var footer = el('form', 'clcb-footer');
  var input = el('input', 'clcb-input');
  input.type = 'text';
  input.placeholder = 'Type your question...';
  input.setAttribute('aria-label', 'Type your question');
  var send = el('button', 'clcb-send', 'Send');
  send.type = 'submit';
  footer.appendChild(input);
  footer.appendChild(send);

  win.appendChild(header);
  win.appendChild(body);
  win.appendChild(footer);
  root.appendChild(launcher);
  root.appendChild(win);

  /* ---------- message API ---------- */
  function scroll() { body.scrollTop = body.scrollHeight; }

  function userSay(text) {
    safe(function () { chatLogMsg(text); });
    body.appendChild(el('div', 'clcb-msg user', esc(text)));
    scroll();
  }

  function botSay(html, delay) {
    return new Promise(function (resolve) {
      var t = el('div', 'clcb-msg bot', '<span class="clcb-typing"><i></i><i></i><i></i></span>');
      body.appendChild(t);
      scroll();
      setTimeout(function () {
        t.innerHTML = html;
        scroll();
        resolve();
      }, delay == null ? 450 : delay);
    });
  }

  function chips(list) {
    Array.prototype.forEach.call(body.querySelectorAll('.clcb-chips'), function (n) { n.parentNode.removeChild(n); });
    var wrap = el('div', 'clcb-chips');
    list.forEach(function (c) {
      var b = el('button', 'clcb-chip', esc(c.label));
      b.type = 'button';
      b.addEventListener('click', function () {
        if (c.href) { if (c.newTab) { window.open(c.href, '_blank', 'noopener'); } else { window.location.href = c.href; } return; }
        wrap.parentNode && wrap.parentNode.removeChild(wrap);
        userSay(c.label);
        run(c.action);
      });
      wrap.appendChild(b);
    });
    body.appendChild(wrap);
    scroll();
  }

  /* ---------- WhatsApp handoff ---------- */
  function waLink(text) {
    var num = (CFG.whatsapp || '').replace(/\D/g, '');
    return 'https://wa.me/' + num + '?text=' + encodeURIComponent(text + waSummary(text));
  }
  function pageContext() {
    if (PAGE.product) return 'Product: ' + PAGE.product.title + ' - ' + location.href;
    if (PAGE.collection) return 'Collection: ' + PAGE.collection.title + ' - ' + location.href;
    return 'Page: ' + location.href;
  }

  /* ---------- page-aware greeting ---------- */
  function greeting() {
    if (PAGE.product) {
      var p = PAGE.product;
      return {
        text: 'Hi! 👋 Looking at <b>' + esc(p.title) + '</b> (' + (p.variantCount > 1 ? 'from ' : '') + money(p.price) + '). What would you like to know?',
        chips: [
          { label: 'Choose options & add to cart', action: 'product_options' },
          { label: 'Price & availability', action: 'product_price' },
          { label: 'Specs & compatibility', action: 'product_specs' },
          /silicone/i.test((p.title || '') + ' ' + (p.handle || '')) && !/accessor|end-cap|sleeve|neon/i.test((p.title || '') + ' ' + (p.handle || '')) ? { label: 'Build my end caps & clips kit', action: 'silicone_kit' } : null,
          { label: 'You may also like', action: 'related' },
          { label: 'Shipping & delivery', action: 'shipping' },
          { label: 'Talk to a person', action: 'human' }
        ]
      };
    }
    if (PAGE.collection) {
      return {
        text: 'Hi! 👋 Browsing <b>' + esc(PAGE.collection.title) + '</b>? I can help you pick the right product.',
        chips: [
          { label: 'Help me choose', action: 'finder' },
          { label: 'Current offers', action: 'offers' },
          { label: 'Shipping & delivery', action: 'shipping' },
          { label: 'Returns & replacements', action: 'returns' },
          { label: 'Talk to a person', action: 'human' }
        ]
      };
    }
    if (PAGE.template === 'cart') {
      return {
        text: 'Hi! 👋 Need help with your cart or checkout?',
        chips: [
          { label: 'Review my cart', action: 'cart' },
          { label: 'Help me reach free delivery', action: 'topup' },
          { label: 'Current offers', action: 'offers' },
          { label: 'Shipping & delivery', action: 'shipping' },
          { label: 'Talk to a person', action: 'human' }
        ]
      };
    }
    return {
      text: 'Welcome to <b>Chronos</b>! 👋 How can I help you today?',
      chips: MENU
    };
  }

  /* ---------- flows (Stage 2: knowledge from chronoslights.com) ---------- */
  var C = {
    phone: '+91-7277798111',
    email: 'support@chronoslights.com',
    hours: 'Monday to Saturday, 10:00 AM – 7:00 PM IST (Sunday closed)'
  };

  var MENU = [
    { label: 'Shop products', action: 'choose' },
    { label: 'My cart', action: 'cart' },
    { label: 'Current offers', action: 'offers' },
    { label: 'Shipping & delivery', action: 'shipping' },
    { label: 'Returns & replacements', action: 'returns' },
    { label: 'Custom neon signs', action: 'neon' },
    { label: 'Bulk & corporate', action: 'bulk' },
    { label: 'Contact us', action: 'contact' },
    { label: '☰ More options', action: 'menu' }
  ];

  function btn(href, label) {
    return '<a href="' + href + '" target="_blank" rel="noopener" ' +
      'style="display:inline-block;background:#D9A521;color:#000;padding:8px 14px;border-radius:18px;font-weight:700;text-decoration:none;margin-top:6px">' + label + '</a>';
  }
  function say(html) { return botSay(html); }

  var flows = {
    /* ----- product page ----- */
    product_price: function () {
      var p = PAGE.product;
      return say('<b>' + esc(p.title) + '</b><br>Price: ' + money(p.price) + ' (incl. GST)<br>' +
        (p.available ? 'In stock ✅' : 'Currently out of stock')).then(function () {
        chips([
          { label: 'Shipping & delivery', action: 'shipping' },
          { label: 'Returns & replacements', action: 'returns' },
          { label: 'Talk to a person', action: 'human' }
        ]);
      });
    },
    product_options: function () { return startProduct(PAGE.product.handle); },
    related: function () { return related(null); },

    /* ----- shopping ----- */
    choose: function () {
      return say('What are you shopping for?').then(function () {
        chips([
          { label: '🔎 Help me choose', action: 'finder' },
          { label: 'Silicone neon lights', href: '/collections/ac-220v-silicone-profile-neon-lights' },
          { label: 'Strip lights', href: '/collections/strip-lights' },
          { label: 'Rope & strip lights (AC)', href: '/collections/basic-rope-lights' },
          { label: 'Curtain lights', href: '/collections/curtain-lights' },
          { label: 'Pillar candles', href: '/collections/led-jumping-3d-wick-pillar-candles' },
          { label: 'Custom neon signs', href: '/collections/custom-neon-signs' },
          { label: 'Driver calculator', action: 'calc_driver' },
          { label: 'Back to menu', action: 'menu' }
        ]);
      });
    },
    /* ----- shipping ----- */
    shipping: function () {
      return say('🚚 <b>Shipping from Mumbai</b><br>' +
        '• Orders ship within 48 hours. Orders placed after 11:00 AM are processed the next working day.<br>' +
        '• Free delivery on B2C orders of ₹' + (CFG.freeShippingFrom || 1999) + '+.<br>' +
        '• Same-day delivery in Mumbai and 24-hour air delivery to Tier 1 metros are available at extra cost.')
        .then(function () {
          chips([
            { label: 'Delivery time by region', action: 'shipping_regions' },
            { label: 'Track my order', action: 'order' },
            { label: 'Back to menu', action: 'menu' }
          ]);
        });
    },
    shipping_regions: function () {
      return say('Delivery time after shipping (working days):<br>' +
        '• West: 3–5<br>• South: 5–7<br>• North: 5–7<br>• East: 5–7<br>' +
        '• North East & J&K: 7–14<br><br>' +
        '<small>These are estimates and vary by courier.</small>')
        .then(function () { chips(MENU); });
    },
    order: function () {
      return say('For order status or tracking, message our team on WhatsApp with your <b>order number</b>.<br>' +
        btn(waLink('Hi Chronos, I need an update on my order. Order no: '), 'Message us on WhatsApp'))
        .then(function () { chips(MENU); });
    },

    /* ----- returns ----- */
    returns: function () {
      return say('↩️ <b>Returns & replacements</b><br>' +
        'We do not offer refunds or change-of-mind returns. If an item arrives damaged or defective, we replace it.<br><br>' +
        '• Report within <b>7 days</b> of delivery.<br>' +
        '• Keep an unboxing video. Claims without one may be delayed or denied.')
        .then(function () {
          chips([
            { label: 'Start a replacement claim', action: 'claim' },
            { label: 'What can’t be returned', action: 'returns_no' },
            { label: 'Refunds', action: 'refund' },
            { label: 'Back to menu', action: 'menu' }
          ]);
        });
    },
    returns_claim: function () {
      var href = waLink('Hi Chronos, my item arrived damaged/defective. Order no: ');
      return say('<b>To claim a replacement:</b><br>' +
        '1. Record a video while unboxing.<br>2. Message us on WhatsApp within 7 days of delivery.<br>' +
        '3. Our team reviews the video and product condition.<br>4. If valid, we send a replacement.<br>' +
        btn(href, 'Report on WhatsApp')).then(function () { chips(MENU); });
    },
    returns_no: function () {
      return say('<b>Not returnable:</b><br>' +
        '• Flexible Silicone Profiles and Silicone Profile Neon Lights (including custom-cut), unless damaged or defective on arrival<br>' +
        '• Button cell batteries<br>' +
        '• Items cut, installed, altered or damaged by misuse<br>' +
        '• Change of mind or incorrect orders<br>' +
        '• Sale items (replacement only if defective)')
        .then(function () { chips(MENU); });
    },
    returns_refund: function () {
      return flows.refund();
    },

    /* ----- custom neon ----- */
    neon: function () {
      return say('✨ <b>Custom neon signs</b>, made with your name, quote or design. You choose the size, font and colour.<br><br>' +
        '• <b>GEN1 Eco Neon Sign:</b> ₹1,495<br>' +
        '• <b>GEN2 Premium Neon Sign:</b> ₹1,995<br>' +
        '<small>Prices include GST.</small><br><br>' +
        btn('/collections/custom-neon-signs', 'Design your sign'))
        .then(function () {
          chips([
            { label: 'Production time', action: 'human' },
            { label: 'Can I return it?', action: 'returns_no' },
            { label: 'Back to menu', action: 'menu' }
          ]);
        });
    },

    /* ----- bulk ----- */
    bulk: function () {
      var num = (CFG.whatsappBulk || CFG.whatsapp || '');
      var href = 'https://wa.me/' + String(num).replace(/\D/g, '') + '?text=' +
        encodeURIComponent('Hi Chronos B2B team, I am interested in bulk pricing. ' + pageContext());
      return say('🏢 <b>Bulk & corporate orders</b><br>' +
        'Bulk pricing and custom branding, packaging and gift wrapping are available for verified B2B customers across India. The larger the quantity, the better the price.<br><br>' +
        '<b>Send our B2B team on WhatsApp:</b><br>' +
        '• Your business visiting card<br>• Screenshot of the products you want<br>' +
        '• Approximate quantity<br>• Delivery location<br>• Expected delivery date<br>' +
        btn(href, 'WhatsApp B2B team')).then(function () { chips([{ label: 'Send my enquiry here', action: 'bulk_lead' }].concat(MENU)); });
    },

    /* ----- contact ----- */
    contact: function () {
      return say('📞 <b>Contact Chronos</b><br>' +
        'WhatsApp / phone: ' + C.phone + ' (fastest)<br>' +
        'Email: ' + C.email + ' (reply in 24–48 hours)<br>' +
        'Support hours: ' + C.hours + '<br>' +
        btn(waLink('Hi Chronos, I need help. ' + pageContext()), 'Open WhatsApp'))
        .then(function () { chips([{ label: 'Request a call back', action: 'callback' }].concat(MENU)); });
    },
    menu: function () {
      return say('What would you like to do?').then(function () {
        chips([
          { label: '🛍 Find & buy', action: 'menu_buy' },
          { label: '📦 Orders', action: 'menu_orders' },
          { label: '🚚 Delivery', action: 'menu_delivery' },
          { label: '💬 Help & contact', action: 'menu_help' }
        ]);
      });
    },
    fallback: function () {
      return say('I’m not sure about that yet. Pick an option below or talk to our team.')
        .then(function () { chips(MENU); });
    }
  };

  /* ---------- grouped feature menu ---------- */
  function menuGroup(title, items) {
    return function () {
      return say(title).then(function () {
        chips(items.concat([{ label: '← Menu', action: 'menu' }]));
      });
    };
  }
  flows.menu_buy = menuGroup('Find & buy', [
    { label: 'Help me choose', action: 'finder' },
    { label: 'Silicone kit builder', action: 'silicone_kit' },
    { label: 'Current offers', action: 'offers' },
    { label: 'Reach free delivery', action: 'topup' }
  ]);
  flows.menu_orders = menuGroup('Orders', [
    { label: 'Track my order', action: 'order' },
    { label: 'Get my invoice', action: 'invoice' },
    { label: 'Cancel / refund', action: 'cancel_order' },
    { label: 'Damaged or wrong item', action: 'claim' }
  ]);
  flows.menu_delivery = menuGroup('Delivery', [
    { label: 'Check my pincode', action: 'pincode' },
    { label: 'Shipping & delivery time', action: 'shipping' },
    { label: 'Store address (Mulund)', action: function () { return handleText('where is your store'); } }
  ]);
  flows.menu_help = menuGroup('Help & contact', [
    { label: 'LED driver calculator', action: 'calc_driver' },
    { label: 'GST invoice', action: 'gst_b2b' },
    { label: 'Bulk & corporate', action: 'bulk' },
    { label: 'Chat on WhatsApp', action: 'contact' },
    { label: 'Request a call back', action: 'callback' }
  ]);

  function run(action) {
    if (typeof action === 'function') return action();
    return (flows[action] || flows.fallback)();
  }

  /* =====================================================================
     Stage 3: live product help (data from Shopify, no server needed)
     ===================================================================== */
  var THRESH = (CFG.freeShippingFrom || 1999) * 100;
  var cache = { products: {}, guard: {} };
  var awaitQty = null;

  function toPaise(p) {
    if (typeof p === 'number') return p;
    var n = parseFloat(String(p == null ? '0' : p).replace(/,/g, ''));
    return Math.round((isNaN(n) ? 0 : n) * 100);
  }
  function imgUrl(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 120);
  }
  function getJSON(url, opts) {
    return fetch(url, opts || { headers: { 'Accept': 'application/json' } }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Request failed');
        return j;
      });
    });
  }
  function getProduct(handle) {
    if (cache.products[handle]) return Promise.resolve(cache.products[handle]);
    return getJSON('/products/' + encodeURIComponent(handle) + '.js').then(function (p) {
      cache.products[handle] = p;
      return p;
    });
  }
  function optName(o) { return typeof o === 'string' ? o : (o && o.name) || 'Option'; }
  function backChips(extra) {
    chips((extra || []).concat([
      { label: 'Talk to a person', action: 'human' },
      { label: 'Back to menu', action: 'menu' }
    ]));
  }

  /* Products that need choices made on the product page (length, add-ons,
     bulk pricing) must not be added from chat, or the order would be wrong. */
  function excludedBySettings(p) {
    var list = (CFG.exclude || []).map(function (s) { return String(s).trim().toLowerCase(); }).filter(Boolean);
    if (!list.length) return false;
    var hay = [p.handle, p.type].concat(p.tags || []).map(function (s) { return String(s).toLowerCase(); });
    return list.some(function (x) { return hay.indexOf(x) > -1; });
  }
  function needsPageConfig(p) {
    if (excludedBySettings(p)) return Promise.resolve(true);
    if (cache.guard[p.handle] != null) return Promise.resolve(cache.guard[p.handle]);
    return fetch('/products/' + encodeURIComponent(p.handle))
      .then(function (r) { return r.text(); })
      .then(function (h) {
        var yes = /name=["']properties\[/i.test(h);   // custom selectors send line-item properties
        cache.guard[p.handle] = yes;
        return yes;
      })
      .catch(function () { cache.guard[p.handle] = false; return false; });
  }
  function scrollToForm() {
    close();
    var f = document.querySelector('form[action*="/cart/add"]') || document.querySelector('.product-form, [data-product-form]');
    if (f && f.scrollIntoView) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function pageHandoff(p) {
    var onPage = PAGE.product && PAGE.product.handle === p.handle;
    return say('<b>' + esc(p.title) + '</b> has options you set on the product page (such as length or add-ons), so I’ll point you there to get it exactly right.')
      .then(function () {
        if (onPage) {
          backChips([{ label: 'Show me the options', action: scrollToForm }]);
        } else {
          chips([
            { label: 'Open product page', href: '/products/' + p.handle },
            { label: 'Talk to a person', action: 'human' },
            { label: 'Back to menu', action: 'menu' }
          ]);
        }
      });
  }

  function discountPct(v) {
    return (v.compare_at_price && v.compare_at_price > v.price) ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
  }
  function cardHtml(p, v) {
    var d = discountPct(v);
    var img = (v && v.featured_image && v.featured_image.src) || p.featured_image || '';
    var vt = (v && v.title && v.title !== 'Default Title') ? '<div class="s">' + esc(v.title) + '</div>' : '';
    return '<div class="clcb-card">' +
      (img ? '<img src="' + esc(imgUrl(img, 120)) + '" alt="" loading="lazy">' : '') +
      '<div><div class="t">' + esc(p.title) + '</div>' + vt +
      '<div><span class="clcb-price">' + money(v.price) + '</span>' +
      (d ? '<span class="clcb-was">' + money(v.compare_at_price) + '</span><span class="clcb-off">' + d + '% OFF</span>' : '') +
      '</div><div class="s">' + (v.available ? 'In stock ✅' : 'Sold out') + ' · incl. GST</div></div></div>';
  }

  function startProduct(handle) {
    return getProduct(handle).then(function (p) {
      return needsPageConfig(p).then(function (guard) {
        if (guard) return pageHandoff(p);
        if (p.variants.length === 1) return showVariant(p, p.variants[0]);
        return askOption(p, 0, []);
      });
    }).catch(function () {
      return say('I couldn’t load that product right now. Our team can help.').then(function () { backChips(); });
    });
  }

  function askOption(p, i, chosen) {
    if (i >= p.options.length) {
      var v = p.variants.filter(function (x) {
        return chosen.every(function (c, k) { return x['option' + (k + 1)] === c; });
      })[0];
      return showVariant(p, v);
    }
    var matching = p.variants.filter(function (x) {
      return chosen.every(function (c, k) { return x['option' + (k + 1)] === c; });
    });
    var vals = [], avail = {};
    matching.forEach(function (x) {
      var val = x['option' + (i + 1)];
      if (vals.indexOf(val) < 0) vals.push(val);
      if (x.available) avail[val] = true;
    });
    if (vals.length === 1 && avail[vals[0]]) return askOption(p, i + 1, chosen.concat([vals[0]]));
    var title = i === 0 ? '<b>' + esc(p.title) + '</b><br>' : '';
    return say(title + 'Choose <b>' + esc(optName(p.options[i])) + '</b>:').then(function () {
      var list = vals.map(function (val) {
        return {
          label: val + (avail[val] ? '' : ' (sold out)'),
          action: function () {
            if (!avail[val]) {
              return say('Sorry, that one is sold out. Please pick another.').then(function () { return askOption(p, i, chosen); });
            }
            return askOption(p, i + 1, chosen.concat([val]));
          }
        };
      });
      chips(list.concat([{ label: 'Back to menu', action: 'menu' }]));
    });
  }

  function showVariant(p, v) {
    if (!v) {
      return say('That combination isn’t available. Let’s pick again.').then(function () { return askOption(p, 0, []); });
    }
    if (!v.available) {
      return say(cardHtml(p, v) + 'This option is currently sold out.').then(function () {
        backChips([{ label: 'Notify me when available', action: function () { return notifyLead(p, v); } }, { label: 'Choose another option', action: function () { return askOption(p, 0, []); } }]);
      });
    }
    return say(cardHtml(p, v) + 'How many would you like?').then(function () {
      chips([
        { label: 'Add 1 to cart', action: function () { return addToCart(p, v, 1, false); } },
        { label: 'Add 2', action: function () { return addToCart(p, v, 2, false); } },
        { label: 'Add 5', action: function () { return addToCart(p, v, 5, false); } },
        { label: 'Other quantity', action: function () {
            awaitQty = { p: p, v: v };
            return say('Type the quantity you need, for example 3.');
        } },
        { label: 'Buy now', action: function () { return addToCart(p, v, 1, true); } },
        { label: 'Different option', action: function () { return askOption(p, 0, []); } }
      ]);
    });
  }

  function refreshTheme(cart) {
    safe(function () {
      ['cart:refresh', 'cart:updated', 'cart:change', 'theme:cart:change'].forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } }));
      });
    });
  }

  function addToCart(p, v, qty, checkout) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
        return j;
      });
    }).then(function () {
      return getJSON('/cart.js');
    }).then(function (cart) {
      refreshTheme(cart);
      if (checkout) {
        say('Added! Taking you to your cart to check out…');
        setTimeout(function () { window.location.href = '/cart'; }, 700);
        return;
      }
      var left = THRESH - cart.total_price;
      var nudge = left > 0
        ? '🚚 Add ' + money(left) + ' more for <b>free delivery</b>.'
        : '🎉 You’ve unlocked <b>free delivery</b>!';
      return say('✅ Added ' + qty + ' × <b>' + esc(p.title) + '</b><br>' +
        'Cart: ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' · ' + money(cart.total_price) + '<br>' + nudge)
        .then(function () { return upsellMsg(cart); })
        .then(function () {
          chips([
            { label: 'View cart & checkout', href: '/cart' },
            { label: 'You may also like', action: function () { return related(p); } },
            { label: left > 0 ? 'Help me reach free delivery' : 'Keep shopping', action: left > 0 ? 'topup' : 'choose' },
            { label: 'Talk to a person', action: 'human' }
          ]);
        });
    }).catch(function (e) {
      return say('Sorry, I couldn’t add that: ' + esc(e.message || 'something went wrong') + '.').then(function () { backChips(); });
    });
  }

  function showCards(list, heading, after) {
    var html = heading ? '<div style="margin-bottom:4px">' + heading + '</div>' : '';
    list.filter(function (x) { return !isHidden(x.handle); }).slice(0, 4).forEach(function (x) {
      var handle = x.handle || '';
      if (!handle) return;
      var fi = typeof x.featured_image === 'string' ? x.featured_image : (x.featured_image && (x.featured_image.url || x.featured_image.src));
      var img = fi || (typeof x.image === 'string' ? x.image : (x.image && x.image.src)) || '';
      var pr = toPaise(x.price);
      html += '<div class="clcb-card">' +
        (img ? '<img src="' + esc(imgUrl(img, 120)) + '" alt="" loading="lazy">' : '') +
        '<div><div class="t">' + esc(x.title) + '</div>' +
        '<div><span class="clcb-price">' + (pr ? money(pr) : '') + '</span>' +
        (x._off ? '<span class="clcb-was">' + money(x._was) + '</span><span class="clcb-off">' + x._off + '% OFF</span>' : '') + '</div>' +
        '<button type="button" class="clcb-mini" data-clcb-pick="' + esc(handle) + '" data-title="' + esc(x.title) + '">Select</button>' +
        '<a class="clcb-link" href="/products/' + esc(handle) + '" target="_blank" rel="noopener">View</a></div></div>';
    });
    return say(html, 500).then(function () { chips(after || MENU); });
  }
  body.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-clcb-pick]') : null;
    if (!t) return;
    userSay(t.getAttribute('data-title'));
    startProduct(t.getAttribute('data-clcb-pick'));
  });

  function related(p) {
    var id = p ? p.id : (PAGE.product && PAGE.product.id);
    if (!id) return flows.choose();
    return getJSON('/recommendations/products.json?product_id=' + id + '&limit=4&intent=related').then(function (j) {
      var list = j.products || [];
      if (!list.length) return flows.choose();
      return showCards(list, 'You may also like:');
    }).catch(function () { return flows.choose(); });
  }

  function searchProducts(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last';
    return getJSON(url).then(function (j) {
      var list = ((j.resources && j.resources.results && j.resources.results.products) || []).filter(function (x) { return !isHidden(x.handle); });
      if (!list.length) return flows.fallback();
      return showCards(list, 'Here’s what I found for “' + esc(q) + '”:');
    }).catch(function () { return flows.fallback(); });
  }

  /* =====================================================================
     Stage 4: offers and cart assist
     ===================================================================== */
  var OFFER_COLLECTION = CFG.offerCollection || 'diwali-lights';
  var OFFER_TITLE = CFG.offerTitle || 'Diwali Sale';

  /* Best live deals: biggest real discount per product (compare-at price vs price). */
  function bestDeals(handle) {
    return getJSON('/collections/' + encodeURIComponent(handle) + '/products.json?limit=60').then(function (j) {
      var out = [];
      (j.products || []).forEach(function (p) {
        var best = null;
        (p.variants || []).forEach(function (v) {
          var pr = toPaise(v.price), was = toPaise(v.compare_at_price);
          if (!v.available || !was || was <= pr) return;
          var off = Math.round((1 - pr / was) * 100);
          if (!best || off > best.off || (off === best.off && was - pr > best.was - best.price)) {
            best = { off: off, price: pr, was: was };
          }
        });
        if (best) {
          out.push({
            handle: p.handle, title: p.title, price: best.price, _was: best.was, _off: best.off,
            image: p.images && p.images[0] && p.images[0].src
          });
        }
      });
      out.sort(function (a, b) { return (b._off - a._off) || ((b._was - b.price) - (a._was - a.price)); });
      return out;
    });
  }

  flows.offers = function () {
    var lines = (CFG.offers || []).map(function (s) { return String(s).trim(); }).filter(Boolean);
    var html = '🎁 <b>Current offers</b><br>' +
      '• <b>' + esc(OFFER_TITLE) + '</b>: discounts across the store<br>' +
      '• <b>Free delivery</b> on B2C orders of ' + money(THRESH) + '+';
    lines.forEach(function (l) {
      var parts = l.split('|');
      html += '<br>• <b>' + esc(parts[0].trim()) + '</b>' +
        (parts.length > 1 ? ': ' + esc(parts.slice(1).join('|').trim()) : '');
    });
    html += '<br>' + btn('/collections/' + OFFER_COLLECTION, 'Shop ' + esc(OFFER_TITLE));
    return say(html).then(function () {
      return bestDeals(OFFER_COLLECTION).then(function (deals) {
        if (!deals.length) return chips(MENU);
        return showCards(deals.slice(0, 4), '🔥 Top deals right now:');
      }).catch(function () { chips(MENU); });
    });
  };

  /* ----- cart assist ----- */
  function getCart() { return getJSON('/cart.js'); }
  function barHtml(total) {
    var pct = Math.max(0, Math.min(100, Math.round(total / THRESH * 100)));
    return '<div class="clcb-bar"><i style="width:' + pct + '%"></i></div>';
  }
  function freeLine(total) {
    var left = THRESH - total;
    return left > 0
      ? 'Add <b>' + money(left) + '</b> more for <b>free delivery</b>.'
      : '🎉 <b>Free delivery</b> unlocked!';
  }

  flows.cart = function () {
    return getCart().then(function (cart) {
      if (!cart.item_count) {
        return say('Your cart is empty right now.').then(function () {
          chips([
            { label: 'Top deals', action: 'offers' },
            { label: 'Shop products', action: 'choose' },
            { label: 'Back to menu', action: 'menu' }
          ]);
        });
      }
      var html = '🛒 <b>Your cart</b><br>';
      cart.items.slice(0, 6).forEach(function (it) {
        var vt = it.variant_title ? ' (' + esc(it.variant_title) + ')' : '';
        html += '• ' + it.quantity + ' × ' + esc(it.product_title) + vt + ' — ' + money(it.final_line_price) + '<br>';
      });
      if (cart.items.length > 6) html += '…and ' + (cart.items.length - 6) + ' more<br>';
      html += '<b>Total: ' + money(cart.total_price) + '</b> <small>(before shipping)</small>' +
        barHtml(cart.total_price) + freeLine(cart.total_price);
      return say(html).then(function () { return upsellMsg(cart); }).then(function () {
        var list = [{ label: 'View cart & checkout', href: '/cart' }];
        if (cart.total_price < THRESH) list.push({ label: 'Help me reach free delivery', action: 'topup' });
        list.push({ label: 'Remove an item', action: 'cart_edit' });
        list.push({ label: 'Current offers', action: 'offers' });
        list.push({ label: 'Talk to a person', action: 'human' });
        chips(list);
      });
    }).catch(function () {
      return say('I couldn’t load your cart. You can open it here.').then(function () {
        backChips([{ label: 'Open cart', href: '/cart' }]);
      });
    });
  };

  function removeLine(key) {
    return getJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (cart) {
      refreshTheme(cart);
      return say('Removed ✅').then(function () { return flows.cart(); });
    }).catch(function () {
      return say('Sorry, I couldn’t remove that. You can edit it on the cart page.').then(function () {
        backChips([{ label: 'Open cart', href: '/cart' }]);
      });
    });
  }
  flows.cart_edit = function () {
    return getCart().then(function (cart) {
      if (!cart.item_count) return flows.cart();
      return say('Which item should I remove?').then(function () {
        var list = cart.items.slice(0, 5).map(function (it) {
          var t = it.product_title.length > 26 ? it.product_title.slice(0, 25) + '…' : it.product_title;
          return { label: 'Remove: ' + t, action: function () { return removeLine(it.key); } };
        });
        chips(list.concat([{ label: 'Keep everything', action: 'cart' }]));
      });
    }).catch(function () { return flows.cart(); });
  };

  /* Suggest products that close the gap to free delivery. */
  flows.topup = function () {
    return getCart().then(function (cart) {
      if (!cart.item_count) return flows.offers();
      var gap = THRESH - cart.total_price;
      if (gap <= 0) {
        return say('🎉 You already have <b>free delivery</b>. Ready to check out?').then(function () {
          chips([{ label: 'View cart & checkout', href: '/cart' }, { label: 'Back to menu', action: 'menu' }]);
        });
      }
      var last = cart.items[cart.items.length - 1];
      var inCart = {};
      cart.items.forEach(function (it) { inCart[it.handle] = true; });
      return Promise.all([
        getJSON('/recommendations/products.json?product_id=' + last.product_id + '&limit=10&intent=related')
          .then(function (j) { return j.products || []; }).catch(function () { return []; }),
        bestDeals(OFFER_COLLECTION).catch(function () { return []; })
      ]).then(function (r) {
        var seen = {}, all = [];
        r[0].concat(r[1]).forEach(function (x) {
          if (!x.handle || seen[x.handle] || inCart[x.handle] || x.available === false) return;
          seen[x.handle] = 1;
          all.push(x);
        });
        var one = all.filter(function (x) { return toPaise(x.price) >= gap; })
          .sort(function (a, b) { return toPaise(a.price) - toPaise(b.price); });
        var pick = one.length ? one.slice(0, 4) : all.slice(0, 4);
        if (!pick.length) {
          return say('Add ' + money(gap) + ' more to unlock free delivery. Browse the store for more.').then(function () {
            chips([{ label: 'Shop products', action: 'choose' }, { label: 'Back to menu', action: 'menu' }]);
          });
        }
        var head = '<b>' + money(gap) + '</b> to go for free delivery. ' +
          (one.length ? 'Any of these gets you there:' : 'A few of these together will get you there:');
        return showCards(pick, head);
      });
    }).catch(function () { return flows.cart(); });
  };

  /* =====================================================================
     Stage 5: lead capture (saved to Google Sheet through an Apps Script web app)
     ===================================================================== */
  var awaiting = null;
  var lastQuestion = '';
  var PRIVACY = CFG.privacyUrl || '/policies/privacy-policy';

  function ss(k, v) {
    return safe(function () {
      if (v === undefined) return sessionStorage.getItem(k);
      sessionStorage.setItem(k, v);
      return v;
    });
  }
  var SID = ss('clcb_sid') || (function () {
    var s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    ss('clcb_sid', s);
    return s;
  })();
  var UTM = (function () {
    var saved = safe(function () { return JSON.parse(sessionStorage.getItem('clcb_utm') || 'null'); });
    if (saved) return saved;
    var u = {};
    safe(function () {
      var q = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) { if (q.get(k)) u[k] = q.get(k); });
    });
    if (Object.keys(u).length) ss('clcb_utm', JSON.stringify(u));
    return u;
  })();
  function savedContact() {
    return safe(function () { return JSON.parse(sessionStorage.getItem('clcb_contact') || 'null'); }) || {};
  }

  function normPhone(t) {
    var s = String(t || '').replace(/[\s\-().]/g, '');
    var d = s.replace(/\D/g, '');
    if (s.charAt(0) === '+' && s.indexOf('+91') !== 0) return /^\+\d{8,15}$/.test(s) ? s : null;
    if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2);
    else if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
    return /^[6-9]\d{9}$/.test(d) ? '+91' + d : null;
  }

  var S_NAME = { key: 'name', prompt: 'What’s your name?',
    validate: function (v) { return (v.length < 2 || v.length > 60) ? 'Please enter your name.' : ''; } };
  var S_PHONE = { key: 'phone', prompt: 'Your mobile number? (WhatsApp preferred)', norm: normPhone,
    validate: function (v) { return normPhone(v) ? '' : 'Please enter a valid 10-digit mobile number, or a number with country code like +971…'; } };
  var S_EMAIL = { key: 'email', prompt: 'Email address? (optional)', optional: true,
    validate: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? '' : 'That email doesn’t look right. Try again, or tap Skip.'; } };

  function cancelCollect() {
    awaiting = null;
    return say('No problem. What else can I help with?').then(function () { chips(MENU); });
  }

  /* Ask the steps one by one, then submit. Steps already known this session are skipped. */
  function collect(steps, meta) {
    var data = {};
    var known = savedContact();
    function ask(i) {
      if (i >= steps.length) { awaiting = null; return submitLead(meta, data); }
      var s = steps[i];
      if (s.preset !== undefined) { data[s.key] = s.preset; return ask(i + 1); }
      if (known[s.key] && (s.key === 'name' || s.key === 'phone')) { data[s.key] = known[s.key]; return ask(i + 1); }
      return say(s.prompt).then(function () {
        if (s.options) {
          awaiting = null;
          chips(s.options.map(function (o) {
            return { label: o, action: function () { data[s.key] = o; return ask(i + 1); } };
          }).concat([{ label: 'Cancel', action: cancelCollect }]));
          return;
        }
        awaiting = {
          handle: function (text) {
            var v = text.trim();
            if (/^(cancel|stop|menu|back)$/i.test(v)) return cancelCollect();
            if (s.optional && /^skip$/i.test(v)) v = '';
            else if (s.validate) {
              var err = s.validate(v);
              if (err) return say(err);
            }
            data[s.key] = (s.norm && v) ? s.norm(v) : v;
            awaiting = null;
            return ask(i + 1);
          }
        };
        var c = [];
        if (s.optional) c.push({ label: 'Skip', action: function () { awaiting = null; data[s.key] = ''; return ask(i + 1); } });
        c.push({ label: 'Cancel', action: cancelCollect });
        chips(c);
      });
    }
    return ask(0);
  }

  function consentLine() {
    return 'By sharing your details you agree to be contacted about your enquiry (<a href="' + esc(PRIVACY) +
      '" target="_blank" rel="noopener" style="color:#D9A521">Privacy Policy</a>).';
  }

  function leadWaLink(meta, d) {
    var parts = ['Hi Chronos, this is ' + (d.name || 'a customer') + '.'];
    if (meta.topic) parts.push(meta.topic);
    if (d.order) parts.push('Order no: ' + d.order + '.');
    if (d.issue) parts.push(d.issue + '.');
    if (d.message) parts.push(d.message);
    parts.push(pageContext());
    var num = (meta.source === 'bulk' && CFG.whatsappBulk) ? CFG.whatsappBulk : CFG.whatsapp;
    return 'https://wa.me/' + String(num || '').replace(/\D/g, '') + '?text=' + encodeURIComponent(parts.join(' ') + waSummary(parts.join(' ')));
  }

  function submitLead(meta, d) {
    return getCart().catch(function () { return null; }).then(function (cart) {
      var items = (cart && cart.items) ? cart.items.slice(0, 8).map(function (it) {
        return it.quantity + ' x ' + it.product_title + (it.variant_title ? ' (' + it.variant_title + ')' : '');
      }).join('; ') : '';
      var pp = PAGE.product || {};
      var payload = {
        token: CFG.leadToken || '',
        source: meta.source,
        name: d.name || '', phone: d.phone || '', email: d.email || '', company: d.company || '',
        preferredTime: d.time || '', message: (d.order || d.issue) ? ['Order ' + (d.order || '?'), d.issue, d.message].filter(Boolean).join(' | ') : (d.message || meta.prefill || ''),
        product: meta.product || pp.title || '', productHandle: meta.handle || pp.handle || '', variant: meta.variant || '',
        pageUrl: location.href, pageTitle: document.title,
        cartItems: items, cartTotal: cart ? Math.round(cart.total_price / 100) : '',
        utmSource: UTM.utm_source || '', utmMedium: UTM.utm_medium || '', utmCampaign: UTM.utm_campaign || '',
        referrer: document.referrer || '', session: SID,
        consent: 'Agreed in chat ' + new Date().toISOString()
      };
      var ep = String(CFG.leadEndpoint || '').trim();
      if (!/^https:\/\/script\.google\.com\//.test(ep)) {
        throw new Error('Lead endpoint is empty or not an Apps Script web app URL. Value seen: "' + ep + '"');
      }
      var body = JSON.stringify(payload);
      var hdr = { 'Content-Type': 'text/plain;charset=utf-8' };
      var hints = {
        auth: 'The token in the theme does not match TOKEN in Code.gs.',
        phone: 'The phone number was rejected by the script.',
        rate: 'Too many submissions for this number in the last hour.',
        server: 'The script hit an error. Open Apps Script > Executions to read it.'
      };
      // 1) Normal request, so we can read the script's answer.
      return fetch(ep, { method: 'POST', headers: hdr, body: body, redirect: 'follow' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j || j.ok !== true) {
            throw new Error('The lead service said no: ' + ((j && j.error) || 'unknown') + '. ' + (hints[j && j.error] || ''));
          }
          return 'verified';
        }, function () {
          // 2) The reply could not be read (browser or sign-in redirect). Send once the blind way.
          return fetch(ep, { method: 'POST', mode: 'no-cors', headers: hdr, body: body }).then(function () {
            if (/[?&]clcb_debug=1/.test(location.search)) {
              say('<small>Debug: the lead was sent but the reply could not be read. If no row appears in the Sheet, the web app is probably restricted: set Who has access to Anyone and redeploy.</small>');
            }
            return 'unverified';
          }, function (e1) {
            var queued = safe(function () { return navigator.sendBeacon(ep, new Blob([body], { type: 'text/plain;charset=UTF-8' })); });
            if (queued) return 'unverified';
            throw new Error('Could not reach the lead endpoint (' + (e1 && e1.message ? e1.message : e1) + '). Check the URL, the deployment access ("Anyone") and any extension blocking script.google.com.');
          });
        });
    }).then(function () {
      ss('clcb_contact', JSON.stringify({ name: d.name || '', phone: d.phone || '' }));
      var who = d.name ? ', ' + esc(d.name.split(' ')[0]) : '';
      var msg;
      if (meta.source === 'bulk') {
        msg = 'Thanks' + who + '! Our B2B team will review your requirement and contact you on <b>' + esc(d.phone) + '</b>.';
      } else if (meta.source === 'claim') {
        msg = 'Thanks' + who + '! We’ve logged your replacement request for order <b>' + esc(d.order || '') + '</b>. Our team will contact you on <b>' + esc(d.phone) + '</b>. Please send the unboxing video on WhatsApp to speed things up.' + hoursNote();
      } else if (meta.source === 'invoice') {
        msg = 'Thanks' + who + '! We’ve noted your invoice request for order <b>' + esc(d.order || '') + '</b>. Our team will email it to <b>' + esc(d.email || '') + '</b> during support hours (' + C.hours + ').';
      } else if (meta.source === 'notify') {
        msg = 'Noted' + who + '. We’ll reach out on <b>' + esc(d.phone) + '</b> when this is back in stock.';
      } else {
        msg = 'Thanks' + who + '! Our team will call you on <b>' + esc(d.phone) + '</b> during support hours (' + C.hours + ').';
      }
      return say('✅ ' + msg + (meta.source === 'claim' ? '' : '<br><br>For a faster reply, message us on WhatsApp too.')).then(function () {
        chips([
          { label: 'Chat on WhatsApp', href: leadWaLink(meta, d), newTab: true },
          { label: 'Back to menu', action: 'menu' }
        ]);
      });
    }).catch(function (err) {
      safe(function () { console.warn('[Chronos chatbot] lead not saved:', err && err.message ? err.message : err); });
      if (/[?&]clcb_debug=1/.test(location.search)) { say('<small>Debug: ' + esc(err && err.message ? err.message : String(err)) + '</small>'); }
      return say('I couldn’t save your details just now. Please message us on WhatsApp so nothing gets missed.').then(function () {
        chips([
          { label: 'Chat on WhatsApp', href: leadWaLink(meta, d), newTab: true },
          { label: 'Back to menu', action: 'menu' }
        ]);
      });
    });
  }

  /* ----- lead flows ----- */
  flows.human = function () {
    return say('How would you like to connect with our team?' + hoursNote()).then(function () {
      chips([
        { label: 'Chat on WhatsApp', href: waLink('Hi Chronos, I need help. ' + pageContext()), newTab: true },
        { label: 'Request a call back', action: 'callback' },
        { label: 'Back to menu', action: 'menu' }
      ]);
    });
  };

  flows.callback = function () {
    var q = lastQuestion; lastQuestion = '';
    return say('We’ll call you back during support hours (' + C.hours + ').<br>' + consentLine()).then(function () {
      var steps = [
        S_NAME, S_PHONE,
        { key: 'time', prompt: 'When is the best time to call?', options: ['Morning (10–1)', 'Afternoon (1–4)', 'Evening (4–7)', 'Anytime'] }
      ];
      if (!q) steps.push({ key: 'message', prompt: 'Anything we should know? (optional)', optional: true, validate: function (v) { return v.length > 500 ? 'Please keep it under 500 characters.' : ''; } });
      return collect(steps, {
        source: 'callback',
        topic: q ? 'I have a question: ' + q : 'I requested a call back.',
        prefill: q ? 'Question: ' + q.slice(0, 300) : ''
      });
    });
  };

  flows.bulk_lead = function () {
    return say('Share your requirement and our B2B team will get back to you.<br>' + consentLine()).then(function () {
      return collect([
        S_NAME, S_PHONE,
        { key: 'company', prompt: 'Company name?', validate: function (v) { return v.length < 2 ? 'Please enter your company name.' : ''; } },
        { key: 'message', prompt: 'What do you need, and the approximate quantity?', validate: function (v) { return v.length < 3 ? 'Please add a few details.' : (v.length > 500 ? 'Please keep it under 500 characters.' : ''); } },
        S_EMAIL
      ], { source: 'bulk', topic: 'I have a bulk enquiry.' });
    });
  };

  function notifyLead(p, v) {
    var vt = (v && v.title && v.title !== 'Default Title') ? v.title : '';
    return say('We’ll let you know when <b>' + esc(p.title) + (vt ? ' (' + esc(vt) + ')' : '') + '</b> is back.<br>' + consentLine()).then(function () {
      return collect([S_NAME, S_PHONE], {
        source: 'notify', product: p.title, handle: p.handle, variant: vt,
        topic: 'Please tell me when ' + p.title + (vt ? ' (' + vt + ')' : '') + ' is back in stock.'
      });
    });
  }

  /* =====================================================================
     Stage 6: knowledge base, product facts, and the "ask our team" fallback
     Data lives in assets/cl-knowledge.js (window.CLCB_KB) and, when the lead
     endpoint is set, in the Google Sheet "Knowledge" tab (the sheet wins).
     ===================================================================== */
  var KB = { entries: [], cat: {}, groups: [] };
  var kbReady = null;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (!src) return reject(new Error('no kb asset'));
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = resolve; s.onerror = function () { reject(new Error('kb asset failed')); };
      document.head.appendChild(s);
    });
  }

  /* ----- text matching helpers ----- */
  var STOP = {};
  ('a an the is are was were am be been do does did can could would should will may i me my we our you your it its this that these those ' +
   'there here of to in on at for from with by and or but if so as about into any some what which who how when where why please pls tell show ' +
   'want need get have has had just also ok okay hi hello hey kindly sir madam').split(' ').forEach(function (w) { STOP[w] = 1; });
  var WEAK = { light: 1, lights: 1, led: 1, product: 1, products: 1, buy: 1, item: 1 };
  var SYN = { colour: 'color', colours: 'color', metre: 'meter', metres: 'meter', meters: 'meter', mtr: 'meter', mtrs: 'meter', silicon: 'silicone', waterproof: 'waterproof', cheap: 'price', pricing: 'price', rate: 'price', rates: 'price' };

  function stem(w) {
    if (w.length > 4) {
      var w2 = w.replace(/(ing|ed)$/, '');
      if (w2 !== w) { w = w2.replace(/([bdgmnprt])\1$/, '$1'); }
      else { w = w.replace(/(es|s|e)$/, ''); }
    }
    return w;
  }
  function tok(s) {
    var out = [];
    String(s || '').toLowerCase().replace(/[’']/g, '').split(/[^a-z0-9]+/).forEach(function (w) {
      if (!w || STOP[w]) return;
      w = SYN[w] || w;
      out.push(stem(w));
    });
    return out;
  }
  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i];
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
      }
      prev = cur;
    }
    return prev[b.length];
  }

  var DF = {};
  function prepKB() {
    DF = {};
    KB.entries.forEach(function (e) {
      var seen = {}, toks = {};
      e._p = [];
      (e.kw || []).forEach(function (k) {
        var t = tok(k);
        var key = t.join(' ');
        if (t.length && !seen[key]) { seen[key] = 1; e._p.push(t); t.forEach(function (x) { toks[x] = 1; }); }
      });
      Object.keys(toks).forEach(function (x) { DF[x] = (DF[x] || 0) + 1; });
    });
  }
  /* rarer words weigh more: "damaged" says more than "delivery" */
  function wt(t) {
    var n = Math.max(KB.entries.length, 1), df = DF[t] || 1;
    var w = Math.max(0.5, Math.min(2.5, 0.5 * Math.log(1 + n / df)));
    return WEAK[t] ? w * 0.4 : w;
  }

  /* group of the product page -> knowledge categories that deserve a small boost */
  var GROUP_CATS = {
    'Silicone profiles': ['Silicone profiles'],
    'LED strip lights': ['LED strip lights', 'Drivers & controllers', 'Safety'],
    'Neon flex & rope': ['Neon flex & rope', 'LED strip lights', 'Safety'],
    'Drivers & controllers': ['Drivers & controllers', 'Safety'],
    'String & decor lights': ['String & decor lights'],
    'Neon signs': ['Custom neon signs', 'Neon signs'],
    'Lamps': ['Lamps', 'Kids lamps'],
    'Candles, diyas & lanterns': ['LED candles & diyas'],
    'Marquee & light boxes': ['String & decor lights']
  };
  function pageBoostCats() {
    var r = PAGE.product && KB.cat[PAGE.product.handle];
    var g = r && KB.groups[r[0]];
    return GROUP_CATS[g] || [];
  }

  function scoreAll(text) {
    var q = tok(text);
    var qs = {};
    q.forEach(function (t) { qs[t] = 1; });
    if (!q.length) return [];
    var low = text.toLowerCase();
    var boost = pageBoostCats();
    var res = [];
    KB.entries.forEach(function (e) {
      var matched = {}, bonus = 0;
      e._p.forEach(function (ph) {
        var t, k;
        if (ph.length === 1) {
          t = ph[0];
          if (qs[t]) { matched[t] = 1; }
          else if (t.length >= 5) {
            var m = t.length >= 9 ? 2 : 1;
            for (k in qs) { if (lev(t, k, m) <= m) { if (!matched[k]) matched[k] = 0.6; break; } }
          }
        } else {
          var hit = 0;
          ph.forEach(function (x) { if (qs[x]) hit++; });
          if (hit === ph.length) {
            ph.forEach(function (x) { matched[x] = 1; });
            bonus += 0.5 * (ph.length - 1) + (low.indexOf(ph.join(' ')) > -1 ? 0.5 : 0);
          } else if (ph.length >= 3 && hit === ph.length - 1) {
            ph.forEach(function (x) { if (qs[x]) matched[x] = Math.max(matched[x] || 0, 1); });
            bonus += 0.3;
          }
        }
      });
      var keys = Object.keys(matched);
      if (!keys.length) return;
      var s = bonus;
      keys.forEach(function (k) { s += wt(k) * matched[k]; });
      s = s * (0.8 + 0.2 * Math.min(1, keys.length / q.length));
      if (boost.indexOf(e.cat) > -1) s += 0.7;
      res.push({ e: e, s: s });
    });
    res.sort(function (a, b) { return b.s - a.s; });
    return res;
  }

  /* ----- answers ----- */
  function btnToChip(b, q) {
    var t = b.t;
    if (t === 'WA') return { label: b.l, href: waLink('Hi Chronos, ' + (q ? 'I have a question: ' + q + '. ' : 'I need help. ') + pageContext()), newTab: true };
    if (t === 'CALLBACK') return { label: b.l, action: function () { lastQuestion = q || ''; return flows.callback(); } };
    if (t === 'BULK_LEAD') return { label: b.l, action: 'bulk_lead' };
    if (t === 'CHOOSE') return { label: b.l, action: 'choose' };
    if (t === 'KIT') return { label: b.l, action: 'silicone_kit' };
    if (t === 'PINCODE') return { label: b.l, action: 'pincode' };
    if (t === 'CLAIM') return { label: b.l, action: 'claim' };
    if (t === 'GST_B2B') return { label: b.l, action: 'gst_b2b' };
    if (t === 'NOTIFY') return { label: b.l, action: 'notify_generic' };
    if (/^\//.test(t)) return { label: b.l, href: t, newTab: true };
    return null;
  }

  /* ----- site notices (text and dates are editable in cl-knowledge.js: window.CLCB_NOTICE) ----- */
  function istDate() {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); }
    catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  function noticeHtml(kind) {
    var N = window.CLCB_NOTICE; if (!N) return '';
    var d = istDate(), out = [];
    if ((kind === 'delay' || kind === 'all') && N.delay && (!N.delayUntil || d <= N.delayUntil)) out.push('⏳ ' + esc(N.delay));
    if ((kind === 'ship' || kind === 'all') && N.shipUntil && N.shipBefore && N.shipAfter && (!N.shipEnds || d <= N.shipEnds)) out.push('📍 ' + esc(d <= N.shipUntil ? N.shipBefore : N.shipAfter));
    return out.length ? '<br><br><small style="display:block;background:#FFF6DC;border-left:3px solid #D9A521;padding:6px 8px;border-radius:6px;color:#000">' + out.join('<br>') + '</small>' : '';
  }
  var NOTICE_ENTRIES = { KB001: 'all', KB002: 'all', KB003: 'ship', KB004: 'all', KB005: 'ship', KB007: 'delay', KB044: 'delay' };

  function answerEntry(e, q) {
    if (e.live) return run(e.live);
    if (e.pending || !e.a) return unknown(q, e.topic, 'pending ' + e.id);
    var html = esc(e.a).replace(/\n/g, '<br>') + (NOTICE_ENTRIES[e.id] ? noticeHtml(NOTICE_ENTRIES[e.id]) : '');
    return say(html).then(function () {
      var list = [];
      (e.btn || []).slice(0, 2).forEach(function (b) { var c = btnToChip(b, q); if (c) list.push(c); });
      list.push({ label: '👍 Helpful', action: function () {
        lg('helpful');
        return say('Glad that helped! Anything else?').then(function () { chips(MENU); });
      } });
      list.push({ label: '👎 Not helpful', action: function () {
        lg('not_helpful');
        return unknown(q, e.topic, 'not helpful ' + e.id);
      } });
      chips(list);
    });
  }

  function redact(s) {
    return String(s || '')
      .replace(/[\w.+-]+@[\w-]+\.[\w.]+/g, '[email]')
      .replace(/\+?\d[\d\s\-().]{5,}\d/g, '[number]')
      .slice(0, 200);
  }
  var askedLog = {};
  function logQ(q, reason, topic) {
    var ep = String(CFG.leadEndpoint || '').trim();
    if (!/^https:\/\/script\.google\.com\//.test(ep) || !q) return;
    var key = q + '|' + reason;
    if (askedLog[key]) return;
    askedLog[key] = 1;
    var pp = (typeof curProd === 'function' && curProd()) || PAGE.product || {};
    var payload = JSON.stringify({
      token: CFG.leadToken || '', source: 'unanswered', message: redact(q), reason: reason || '', topic: topic || '',
      product: pp.title || '', productHandle: pp.handle || '', pageUrl: location.href, session: SID
    });
    safe(function () {
      fetch(ep, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: payload });
    });
  }

  /* No confirmed answer: hand over to the team, with the question already filled in. */
  function unknown(q, topic, reason) {
    lastQuestion = q || '';
    lg('fallback');
    logQ(q, reason || 'no answer', topic);
    var intro = topic
      ? 'I don’t have a confirmed answer on <b>' + esc(String(topic).toLowerCase()) + '</b> yet.'
      : 'I don’t have a confirmed answer for that yet.';
    return say(intro + ' Rather than guess, let me connect you with our team. They can help right away.<br><small>' + esc(C.hours) + '</small>' + hoursNote()).then(function () {
      chips([
        { label: 'Chat on WhatsApp', href: waLink('Hi Chronos, ' + (q ? 'I have a question: ' + q + '. ' : 'I need help. ') + pageContext()), newTab: true },
        { label: 'Request a call back', action: 'callback' },
        { label: 'Browse products', action: 'choose' },
        { label: 'Back to menu', action: 'menu' }
      ]);
    });
  }
  flows.fallback = function () { return unknown(lastQuestion, '', 'no answer'); };

  flows.notify_generic = function () {
    if (PAGE.product) {
      return getProduct(PAGE.product.handle).then(function (p) {
        var vs = p.variants || [];
        var v = vs.filter(function (x) { return !x.available; })[0] || vs[0];
        return notifyLead(p, v);
      }).catch(function () { return flows.human(); });
    }
    return say('Tell me the product name and I’ll check it, or talk to our team.').then(function () {
      chips([{ label: 'Talk to a person', action: 'human' }, { label: 'Back to menu', action: 'menu' }]);
    });
  };

  /* ----- product facts for the product page (from the catalogue index) ----- */
  var GROUP_TIPS = {
    'Silicone profiles': 'Sold per metre and cut to length. Add end caps and clips in the options, and match the profile to your strip width.',
    'LED strip lights': 'Strips need a driver (power supply) whose voltage matches the strip. Pick the driver and any dimmer or controller in the options.',
    'Neon flex & rope': 'DC versions need a matching driver or adapter. AC 220V versions plug into the mains and need no driver.',
    'Drivers & controllers': 'Always match the voltage to your strip. A 12V driver on a 24V strip will damage it.'
  };
  function catInfo(handle) {
    var r = KB.cat[handle];
    return r ? { type: (KB.types && r[8] >= 0) ? KB.types[r[8]] : '', group: KB.groups[r[0]], hide: r[1], ps: r[2], ip: r[3], volt: r[4], kf: r[5], moq: r[6], bp: r[7] } : null;
  }
  function isHidden(handle) { var r = KB.cat[handle]; return !!(r && r[1]); }

  flows.product_specs = function () {
    var p = PAGE.product;
    if (!p) return flows.choose();
    var c = catInfo(p.handle), rows = [];
    if (c) {
      if (c.ps) rows.push('<b>Power:</b> ' + esc(c.ps));
      if (c.volt) rows.push('<b>Voltage:</b> ' + esc(c.volt));
      if (c.ip) rows.push('<b>Water protection:</b> ' + esc(c.ip));
      if (c.kf && !/^bulk price/i.test(c.kf)) rows.push('<b>Note:</b> ' + esc(c.kf));
      if (c.moq) {
        var bulk = '<b>Bulk:</b> from ' + esc(c.moq) + (c.bp ? ' (' + esc(c.bp) + ')' : '');
        if (/no cod/i.test(c.kf || '')) bulk += '. Bulk-price orders: no COD' + (/no return/i.test(c.kf) ? ', no returns' : '');
        rows.push(bulk);
      }
    }
    var tip = c && GROUP_TIPS[c.group];
    var html = rows.length
      ? '<b>' + esc(p.title) + '</b><br>' + rows.join('<br>') + (tip ? '<br><br>' + esc(tip) : '')
      : (tip ? esc(tip) + '<br><br>' : '') + 'Full specifications are in the description on this page. I can also connect you with our team for anything specific.';
    return say(html).then(function () {
      chips([
        { label: 'Choose options & add to cart', action: 'product_options' },
        { label: 'Ask our team', action: 'human' },
        { label: 'Back to menu', action: 'menu' }
      ]);
    });
  };

  /* ----- load knowledge: bundled file first, then the sheet (if reachable) ----- */
  function mergeRemote(rows) {
    var byId = {};
    KB.entries.forEach(function (e) { byId[e.id] = e; });
    (rows || []).forEach(function (r) {
      var id = String(r.id || '').trim();
      if (!id) return;
      var st = String(r.status || '').toLowerCase();
      if (st === 'disabled') { delete byId[id]; return; }
      var ok = st === 'approved' || st === 'from site';
      var ans = String(r.answer || '').trim();
      var e = {
        id: id, cat: r.category || '', topic: r.topic || '', q: r.question || '',
        kw: String(r.keywords || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean).concat([String(r.topic || '').toLowerCase()]),
        a: '', btn: []
      };
      if (/^live:/i.test(ans)) e.live = 'offers';
      else if (!ok || !ans || /^placeholder/i.test(ans)) e.pending = 1;
      else e.a = ans;
      String(r.buttons || '').split('|').forEach(function (b) {
        var p = b.split('>>');
        if (p.length === 2) e.btn.push({ l: p[0].trim(), t: p[1].trim() });
      });
      byId[id] = e;
    });
    KB.entries = Object.keys(byId).map(function (k) { return byId[k]; });
    prepKB();
  }

  function loadRemote() {
    var ep = String(CFG.leadEndpoint || '').trim();
    if (!/^https:\/\/script\.google\.com\//.test(ep)) return Promise.resolve();
    var cached = safe(function () { return JSON.parse(sessionStorage.getItem('clcb_kb') || 'null'); });
    if (cached && cached.rows && Date.now() - cached.t < 600000) { mergeRemote(cached.rows); return Promise.resolve(); }
    var ctl = window.AbortController ? new AbortController() : null;
    var tm = setTimeout(function () { if (ctl) ctl.abort(); }, 4000);
    return fetch(ep + (ep.indexOf('?') > -1 ? '&' : '?') + 'action=kb&token=' + encodeURIComponent(CFG.leadToken || ''),
      { redirect: 'follow', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        clearTimeout(tm);
        if (j && j.ok && j.rows && j.rows.length) {
          safe(function () { sessionStorage.setItem('clcb_kb', JSON.stringify({ t: Date.now(), rows: j.rows })); });
          mergeRemote(j.rows);
        }
      })
      .catch(function () { clearTimeout(tm); });
  }

  function loadKB() {
    if (kbReady) return kbReady;
    kbReady = (window.CLCB_KB ? Promise.resolve() : loadScript(CFG.kbAsset).catch(function () {}))
      .then(function () {
        var raw = window.CLCB_KB;
        if (raw) { KB.entries = raw.entries || []; KB.cat = raw.cat || {}; KB.groups = raw.groups || []; KB.types = raw.types || []; }
        prepKB();
        return loadRemote();
      })
      .catch(function () {});
    return kbReady;
  }

  /* ---------- typed text: small talk, shortcuts, knowledge, product search, team ---------- */

  /* ----- order tracking: asks order number + phone/email, Apps Script checks Shopify ----- */
  function trackFail(msg) {
    return say(msg).then(function () {
      chips([
        { label: 'Try again', action: 'order' },
        { label: 'Chat on WhatsApp', action: function () { return say(btn(waLink('Hi Chronos, I need an update on my order. Order no: '), 'Message us on WhatsApp')).then(function () { chips(MENU); }); } },
        { label: 'Back to menu', action: 'menu' }
      ]);
    });
  }
  var PAYMENT_LABEL = { paid: 'Paid', pending: 'Payment pending (pay on delivery)', partially_paid: 'Partly paid (balance on delivery)', refunded: 'Refunded', partially_refunded: 'Partly refunded', voided: 'Voided', authorized: 'Authorised' };
  var lastVerified = null;
  function trackShow(j) {
    lastVerified = { order: j.order, gst: !!j.gst };
    var h = '📦 <b>Order ' + esc(j.order) + '</b> · placed ' + esc(j.placed) + '<br>Status: <b>' + esc(j.status) + '</b>';
    if (j.payment && PAYMENT_LABEL[j.payment]) h += '<br>Payment: ' + esc(PAYMENT_LABEL[j.payment]) + (j.total ? ' · Total ₹' + esc(String(j.total)) : '');
    if (j.city) h += '<br>Delivering to: ' + esc(j.city) + (j.zip ? ' ' + esc(j.zip) : '');
    if (j.items && j.items.length) h += '<br><br>' + j.items.map(function (x) { return '• ' + esc(x); }).join('<br>');
    var links = '';
    (j.fulfillments || []).forEach(function (f) {
      h += '<br><br>🚚 ' + (f.courier ? esc(f.courier) : 'Courier') + (f.number ? ' · AWB <b>' + esc(f.number) + '</b>' : '') +
        '<br>Shipped ' + esc(f.shipped) + (f.shipment ? ' · ' + esc(String(f.shipment).replace(/_/g, ' ')) : '');
      if (/^https?:\/\//i.test(f.url || '')) links += btn(f.url, 'Track shipment');
    });
    if (!(j.fulfillments || []).length && !/cancel/i.test(j.status)) h += '<br><br><small>Tracking details are emailed to you once your order is dispatched and booked, and appear here too.</small>';
    h += noticeHtml('delay');
    return say(h + (links ? '<br>' + links : '')).then(function () {
      chips([{ label: 'Get invoice', action: 'invoice' }, { label: 'Track another order', action: 'order' }, { label: 'Talk to a person', action: 'callback' }, { label: 'Back to menu', action: 'menu' }]);
    });
  }
  flows.invoice = function () {
    if (!lastVerified) {
      return say('To send an invoice I first need to confirm your order. Let’s look it up.').then(function () { return flows.order(); });
    }
    var v = lastVerified;
    if (v.gst) {
      return say('Order <b>' + esc(v.order) + '</b> has GST details, so the GST invoice is emailed to you automatically from our side. If you haven’t received it, we can send it again.').then(function () {
        chips([{ label: 'Send it again', action: function () { return invoiceRequest(v); } }, { label: 'Back to menu', action: 'menu' }]);
      });
    }
    return invoiceRequest(v);
  };
  function invoiceRequest(v) {
    lg('invoice_request');
    var S_MAIL = { key: 'email', prompt: 'Which <b>email</b> should we send the invoice to?',
      validate: function (x) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(x) ? '' : 'That doesn’t look like an email address. Please type it like name@example.com.'; } };
    return say('Sure. I’ll pass this to our team for order <b>' + esc(v.order) + '</b>.<br>' + consentLine()).then(function () {
      return collect([{ key: 'order', preset: v.order }, { key: 'issue', preset: 'Invoice request' }, S_NAME, S_PHONE, S_MAIL], { source: 'invoice', topic: 'Invoice request.' });
    });
  }
  flows.order = function () {
    var ep = String(CFG.leadEndpoint || '').trim();
    if (!/^https:\/\/script\.google\.com\//.test(ep)) {
      return say('For order status or tracking, message our team on WhatsApp with your <b>order number</b>.<br>' +
        btn(waLink('Hi Chronos, I need an update on my order. Order no: '), 'Message us on WhatsApp')).then(function () { chips(MENU); });
    }
    var order = '';
    function askContact() {
      return say('Thanks. Now the <b>phone number or email</b> used on that order, so I can confirm it’s yours. <small>I use it only to look up this order and don’t store it.</small>').then(function () {
        awaiting = { handle: function (text) {
          var v = text.trim();
          if (/^(cancel|stop|menu|back)$/i.test(v)) return cancelCollect();
          var isMail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v), ph = v.replace(/\D/g, '');
          if (!isMail && ph.length < 10) return say('Please enter the 10-digit mobile number or the email used at checkout.');
          awaiting = null;
          return say('Checking your order…').then(function () { return lookup(v); });
        } };
        chips([{ label: 'Cancel', action: cancelCollect }]);
      });
    }
    function lookup(contact) {
      var ctl = window.AbortController ? new AbortController() : null;
      var tm = setTimeout(function () { if (ctl) ctl.abort(); }, 15000);
      return fetch(ep, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, redirect: 'follow', signal: ctl ? ctl.signal : undefined,
        body: JSON.stringify({ token: CFG.leadToken || '', source: 'track', order: order, contact: contact, session: SID }) })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          clearTimeout(tm);
          if (j && j.ok) { lg('order_tracked'); return trackShow(j); }
          if (j && j.error === 'rate') return trackFail('Too many attempts. Please try again in a while, or message our team.');
          if (j && j.error === 'unavailable') return trackFail('I can’t reach order tracking right now. Our team can check it for you.');
          return trackFail('I couldn’t find an order matching those details. Please check the order number and the phone or email used at checkout.');
        })
        .catch(function () { clearTimeout(tm); return trackFail('I can’t reach order tracking right now. Our team can check it for you.'); });
    }
    return say('📦 Sure. What’s your <b>order number</b>? (for example #1234, it’s in your confirmation message)' + noticeHtml('delay')).then(function () {
      awaiting = { handle: function (text) {
        var v = text.trim().replace(/\s+/g, '');
        if (/^(cancel|stop|menu|back)$/i.test(v)) return cancelCollect();
        if (!/^#?[A-Za-z]{0,4}-?\d{3,10}$/.test(v)) return say('That doesn’t look like an order number. It’s usually # followed by digits, like #1234.');
        order = v; awaiting = null;
        return askContact();
      } };
      chips([{ label: 'Cancel', action: cancelCollect }]);
    });
  };



  /* ----- visit log: one summary row per visit (questions with phone numbers and emails removed) ----- */
  var SESS = { start: Date.now(), msgs: 0, qs: [], f: {}, v: 0, sent: -1, page: location.href };
  var logTimer = null;
  function lg(k) { SESS.f[k] = (SESS.f[k] || 0) + 1; SESS.v++; schedLog(); }
  function chatLogMsg(text) {
    SESS.msgs++; SESS.v++;
    var q = redact(String(text || '')).replace(/\s+/g, ' ').trim().slice(0, 120);
    if (q && SESS.qs.length < 12) SESS.qs.push(q);
    schedLog();
  }
  function schedLog() { clearTimeout(logTimer); logTimer = setTimeout(function () { flushLog(false); }, 20000); }
  function flushLog(beacon) {
    var ep = String(CFG.leadEndpoint || '').trim();
    if (!/^https:\/\/script\.google\.com\//.test(ep) || !SESS.msgs || SESS.sent === SESS.v) return;
    SESS.sent = SESS.v;
    var payload = JSON.stringify({
      token: CFG.leadToken || '', source: 'chatlog', session: SID, msgs: SESS.msgs,
      seconds: Math.round((Date.now() - SESS.start) / 1000), questions: SESS.qs.join(' | '), flags: SESS.f,
      landing: SESS.page, pageUrl: location.href, utm: [UTM.utm_source, UTM.utm_medium, UTM.utm_campaign].filter(Boolean).join(' / '),
      device: (window.innerWidth || 1024) < 768 ? 'mobile' : 'desktop'
    });
    safe(function () {
      if (beacon && navigator.sendBeacon) { navigator.sendBeacon(ep, new Blob([payload], { type: 'text/plain;charset=utf-8' })); return; }
      fetch(ep, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: payload });
    });
  }
  window.addEventListener('pagehide', function () { flushLog(true); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flushLog(true); });

  var _flowCart = flows.cart;
  flows.cart = function () { lg('cart_viewed'); return _flowCart.apply(this, arguments); };
  var _submitLead = submitLead;
  submitLead = function (meta, d) { lg('lead_' + (meta && meta.source || 'form')); return _submitLead(meta, d); };

  /* ----- upsell: product-specific first, then cart-value tier (mirrors the site's cart upsell) ----- */
  function upsellPick(cart) {
    var U = window.CLCB_UPSELL;
    if (!U || !cart || !cart.items || !cart.items.length) return [];
    var inCart = {}, out = [], seen = {};
    cart.items.forEach(function (it) { inCart[it.handle] = 1; });
    function add(h, r) { if (h && !inCart[h] && !seen[h]) { seen[h] = 1; out.push({ h: h, r: r }); } }
    cart.items.forEach(function (it) { var m = U.map && U.map[it.handle]; if (m) add(m.u, m.r); });
    cart.items.forEach(function (it) { (U.types && U.types[it.product_type] || []).forEach(function (m) { add(m.u, m.r); }); });
    var rupees = cart.total_price / 100;
    (U.tiers || []).some(function (t) { if (rupees < t.upto) { add(t.u, t.r); return true; } return false; });
    return out;
  }
  /* Says one upsell card (with an Add button). Among in-stock candidates, prefers one that closes the gap to free delivery. */
  function upsellMsg(cart) {
    var picks = upsellPick(cart).slice(0, 6);
    if (!picks.length) return Promise.resolve();
    var gap = THRESH - cart.total_price;
    return Promise.all(picks.map(function (pk) {
      return getJSON('/products/' + encodeURIComponent(pk.h) + '.js').then(function (p) {
        var v = p && p.variants && p.variants.filter(function (x) { return x.available; })[0];
        return v ? { p: p, v: v, r: pk.r } : null;
      }).catch(function () { return null; });
    })).then(function (list) {
      list = list.filter(Boolean);
      if (!list.length) return;
      var best = list[0];
      var single = false;
      if (gap > 0) {
        var hit = list.filter(function (x) { return toPaise(x.v.price) >= gap; });
        if (hit.length) { best = hit[0]; best.free = true; single = true; }
      }
      /* no single item does the job: offer a two-item set (different kinds of product) */
      var other = list.filter(function (x) { return x !== list[0] && x.r !== list[0].r; })[0];
      if (!single && other) {
        var a1 = list[0], a2 = other, sum = toPaise(a1.v.price) + toPaise(a2.v.price);
        function row(x) {
          var im = x.p.featured_image || '';
          return '<div class="clcb-card">' + (im ? '<img src="' + esc(imgUrl(im, 120)) + '" alt="" loading="lazy">' : '') +
            '<div><div class="t">' + esc(x.p.title) + '</div><div><span class="clcb-price">' + money(x.v.price) + '</span></div>' +
            '<a class="clcb-link" href="/products/' + esc(x.p.handle) + '" target="_blank" rel="noopener">View</a></div></div>';
        }
        lg('set_shown');
    return say('<div style="margin-bottom:4px">🎁 <b>Complete the set</b><br><small>' + esc(a1.r) + ' · ' + esc(a2.r) +
          (gap > 0 && sum >= gap ? ' · together they unlock <b>free delivery</b>' : '') + '</small></div>' + row(a1) + row(a2) +
          '<button type="button" class="clcb-mini" data-clcb-upsell="' + esc(a1.v.id + ',' + a2.v.id) + '" data-title="both items">+ Add both · ' + money(sum) + '</button>', 400);
      }
      var p = best.p, v = best.v, d = discountPct(v), img = p.featured_image || '';
      lg('upsell_shown');
      return say('<div style="margin-bottom:4px">✨ <b>Goes well with your order</b><br><small>' + esc(best.r) +
        (best.free ? ' · and it unlocks <b>free delivery</b>' : '') + '</small></div>' +
        '<div class="clcb-card">' + (img ? '<img src="' + esc(imgUrl(img, 120)) + '" alt="" loading="lazy">' : '') +
        '<div><div class="t">' + esc(p.title) + '</div><div><span class="clcb-price">' + money(v.price) + '</span>' +
        (d ? '<span class="clcb-was">' + money(v.compare_at_price) + '</span><span class="clcb-off">' + d + '% OFF</span>' : '') + '</div>' +
        '<button type="button" class="clcb-mini" data-clcb-upsell="' + esc(String(v.id)) + '" data-title="' + esc(p.title) + '">+ Add to cart</button>' +
        '<a class="clcb-link" href="/products/' + esc(p.handle) + '" target="_blank" rel="noopener">View</a></div></div>', 400);
    });
  }
  body.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-clcb-upsell]') : null;
    if (!t) return;
    var raw = String(t.getAttribute('data-clcb-upsell')).split(','), ids = [], lines = [];
    raw.forEach(function (x) { var q = x.split(':'); var id = Number(q[0]), n = Math.max(1, Math.min(200, Number(q[1]) || 1)); ids.push(id); lines.push({ id: id, quantity: n }); });
    var isKit = t.getAttribute('data-kit') === '1';
    lg(isKit ? 'kit_added' : (ids.length > 1 ? 'set_added' : 'upsell_added'));
    userSay('Add ' + t.getAttribute('data-title'));
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lines }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return getJSON('/cart.js'); })
      .then(function (cart) { refreshTheme(cart); return say(isKit ? '✅ Your kit is in the cart.' : (ids.length > 1 ? '✅ Both added to your cart.' : '✅ Added to your cart.')).then(function () { return flows.cart(); }); })
      .catch(function () { return say('Sorry, I couldn’t add that. You can add it from the product page.').then(function () { backChips(); }); });
  });


  /* ----- cancel an order: handled by the team on WhatsApp or phone ----- */
  flows.cancel_order = function () {
    lg('cancel_request');
    var tel = 'tel:' + String(C.phone).replace(/[^\d+]/g, '');
    var callBtn = '<a href="' + esc(tel) + '" style="display:inline-block;background:#fff;color:#000;border:2px solid #D9A521;padding:6px 14px;border-radius:18px;font-weight:700;text-decoration:none;margin:6px 6px 0 0">📞 Call ' + esc(C.phone) + '</a>';
    return say('To cancel an order, please contact our team directly. Orders ship within 48 hours, so reach out as soon as you can.<br>' +
      'Keep your <b>order number</b> ready.<br>' +
      btn(waLink('Hi Chronos, I want to cancel my order. Order no: '), '💬 Cancel on WhatsApp') + ' ' + callBtn +
      '<br><small>' + esc(C.hours) + '</small>' + hoursNote()).then(function () {
      chips([{ label: 'Track my order', action: 'order' }, { label: 'Request a call back', action: 'callback' }, { label: 'Back to menu', action: 'menu' }]);
    });
  };


  /* ----- support hours (Mon-Sat 10:00-19:00 IST): tell the visitor when the team is offline ----- */
  function hoursNote() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Kolkata', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      var day = p.weekday, mins = (Number(p.hour) % 24) * 60 + Number(p.minute);
      var sun = day === 'Sun', open = !sun && mins >= 600 && mins < 1140;
      if (open) return '';
      var when;
      if (!sun && mins < 600) when = 'today at 10:00 AM';
      else if (sun || day === 'Sat') when = 'Monday at 10:00 AM';
      else when = 'tomorrow at 10:00 AM';
      return '<br><small>🕒 Our team is offline right now and will reply ' + when + ' (IST).</small>';
    } catch (e) { return ''; }
  }
  function contactButtons(waText) {
    var tel = 'tel:' + String(C.phone).replace(/[^\d+]/g, '');
    return btn(waLink(waText), '💬 WhatsApp') + ' <a href="' + esc(tel) + '" style="display:inline-block;background:#fff;color:#000;border:2px solid #D9A521;padding:6px 14px;border-radius:18px;font-weight:700;text-decoration:none;margin:6px 6px 0 0">📞 Call ' + esc(C.phone) + '</a>';
  }

  /* ----- refunds: replacement only ----- */
  var REFUND_MSG = 'We don’t offer refunds. If your order arrives damaged or defective, we replace it. Please contact our customer support team and keep your order number and unboxing video ready.';
  flows.refund = function () {
    lg('refund_question');
    return say(REFUND_MSG + '<br>' + contactButtons('Hi Chronos, I need help with my order. Order no: ') + '<br><small>' + esc(C.hours) + '</small>' + hoursNote()).then(function () {
      chips([{ label: 'Start a replacement claim', action: 'claim' }, { label: 'Back to menu', action: 'menu' }]);
    });
  };

  /* ----- replacement claim: collects order, issue and contact, saves it as a lead for the team ----- */
  flows.claim = function () {
    lg('claim_started');
    var S_ORDER = { key: 'order', prompt: 'What’s your <b>order number</b>? (for example #1234)',
      validate: function (v) { return /^#?[A-Za-z]{0,4}-?\d{3,10}$/.test(v.replace(/\s+/g, '')) ? '' : 'That doesn’t look like an order number. It’s usually # followed by digits, like #1234.'; },
      norm: function (v) { return v.replace(/\s+/g, ''); } };
    var S_ISSUE = { key: 'issue', prompt: 'What went wrong?', options: ['Arrived damaged', 'Not working / defective', 'Wrong item received', 'Missing item or parts'] };
    var S_NOTE = { key: 'message', prompt: 'Anything else we should know? (optional)', optional: true,
      validate: function (v) { return v.length > 400 ? 'Please keep it under 400 characters.' : ''; } };
    return say('Sorry about that. We replace items that arrive damaged or defective. Please keep your <b>unboxing video</b> ready and report within <b>7 days</b> of delivery.<br>' + consentLine()).then(function () {
      return collect([S_ORDER, S_ISSUE, S_NAME, S_PHONE, S_NOTE], { source: 'claim', topic: 'Replacement claim.' });
    });
  };

  /* ----- driver and power calculator ----- */
  var DRIVER_HANDLE = { 5: '5v-slim-smps-drivers', 12: '12v-slim-smps-drivers', 24: '24v-slim-smps-drivers' };
  flows.calc_driver = function () {
    var st = {};
    function num(text, lo, hi) {
      var m = String(text).replace(',', '.').match(/\d+(\.\d+)?/);
      var n = m ? parseFloat(m[0]) : NaN;
      return (n >= lo && n <= hi) ? n : null;
    }
    function ask(prompt, lo, hi, hint, next) {
      return say(prompt).then(function () {
        awaiting = { handle: function (text) {
          if (/^(cancel|stop|menu|back)$/i.test(text.trim())) return cancelCollect();
          var n = num(text, lo, hi);
          if (n === null) return say(hint);
          awaiting = null;
          return next(n);
        } };
        chips([{ label: 'Cancel', action: cancelCollect }]);
      });
    }
    function result() {
      var total = st.len * st.wpm, need = total * 1.2;
      return getJSON('/products/' + DRIVER_HANDLE[st.volt] + '.js').then(function (p) {
        var opts = (p.variants || []).map(function (v) {
          var m = /(\d+(?:\.\d+)?)\s*W/i.exec(v.title || '');
          return m ? { v: v, w: parseFloat(m[1]) } : null;
        }).filter(function (x) { return x && x.v.available; }).sort(function (a, b) { return a.w - b.w; });
        if (!opts.length) { return say('I can’t find a ' + st.volt + 'V driver in stock right now. Our team can suggest one.' + hoursNote()).then(function () { return flows.human(); }); }
        var pick = opts.filter(function (x) { return x.w >= need; })[0], qty = 1, many = false;
        if (!pick) { pick = opts[opts.length - 1]; qty = Math.ceil(need / pick.w); many = true; }
        lg('calc_done');
        var img = p.featured_image || '';
        var ids = []; for (var i = 0; i < qty; i++) ids.push(pick.v.id);
        var head = '⚡ <b>' + st.len + ' m × ' + st.wpm + ' W/m = ' + (Math.round(total * 10) / 10) + ' W</b><br>' +
          'With a 20% safety margin you need a <b>' + st.volt + 'V driver of at least ' + (Math.ceil(need)) + ' W</b>.' +
          (many ? '<br>The biggest size we stock is ' + pick.w + ' W, so you would need <b>' + qty + ' drivers</b>, each powering part of the strip.' : '') +
          '<br><small>Match the driver voltage to the strip voltage.</small>';
        return say(head + '<div class="clcb-card" style="margin-top:6px">' + (img ? '<img src="' + esc(imgUrl(img, 120)) + '" alt="" loading="lazy">' : '') +
          '<div><div class="t">' + esc(p.title) + '</div><div class="s">' + esc(pick.v.title) + (qty > 1 ? ' × ' + qty : '') + '</div>' +
          '<div><span class="clcb-price">' + money(pick.v.price * qty) + '</span></div>' +
          '<button type="button" class="clcb-mini" data-clcb-upsell="' + esc(ids.join(',')) + '" data-title="' + esc(p.title) + '">+ Add to cart</button>' +
          '<a class="clcb-link" href="/products/' + esc(p.handle) + '" target="_blank" rel="noopener">View</a></div></div>', 400).then(function () {
          chips([{ label: 'Calculate again', action: 'calc_driver' }, { label: 'Talk to a person', action: 'human' }, { label: 'Back to menu', action: 'menu' }]);
        });
      }).catch(function () { return say('I couldn’t load the driver details just now. Our team can help.').then(function () { return flows.human(); }); });
    }
    return say('⚡ <b>Driver calculator</b>. Which voltage is your strip?').then(function () {
      chips([5, 12, 24].map(function (v) {
        return { label: v + 'V', action: function () {
          st.volt = v;
          return ask('How many <b>metres</b> of strip will you power in total?', 0.5, 200, 'Please enter the length in metres, for example 5 or 7.5.', function (len) {
            st.len = len;
            return ask('How many <b>watts per metre</b> is your strip? (it is in the product’s Specifications, for example 9.6)', 1, 60, 'Please enter watts per metre, for example 9.6. If you can’t find it, tap Talk to a person.', function (w) {
              st.wpm = w; return result();
            });
          });
        } };
      }).concat([{ label: 'Not sure', action: function () {
        return say('The voltage is in the product title or Specifications (for example “24V”). Check there and come back, or our team can help.' + hoursNote()).then(function () {
          chips([{ label: 'Talk to a person', action: 'human' }, { label: 'Back to menu', action: 'menu' }]);
        });
      } }]));
    });
  };

  flows.gst_b2b = function () {
    lg('gst_b2b');
    return say('Our GST number is <b>27AWWPD1240P1Z2</b>.<br>To get a GST invoice for your order, enter your own GST details at checkout and the invoice is emailed to you automatically.').then(function () {
      chips([{ label: 'Bulk & corporate', action: function () { location.href = '/pages/bulk-corporate'; } }, { label: 'Back to menu', action: 'menu' }]);
    });
  };

  /* ----- product questions answered from the product's own details (waterproof, remote, adapter, power) ----- */
  var lastProd = null;
  function curProd() { return PAGE.product ? { handle: PAGE.product.handle, title: PAGE.product.title } : lastProd; }
  var _startProduct0 = startProduct;
  startProduct = function (h) { if (!lastProd || lastProd.handle !== h) lastProd = { handle: h, title: '' }; return _startProduct0(h); };

  var PF = [
    { k: 'water', label: 'waterproofing',
      q: /water.?proof|water.?resist|\bip ?\d{2}\b|\boutdoors?\b|\brain\b|\bwet\b|splash|bathroom|garden|balcony|moisture/i,
      f: /\bIP\s?-?\d{2}\b|water.?proof|water.?resist|splash|outdoor|\brain\b|indoor/i },
    { k: 'remote', label: 'a remote',
      q: /\bremote\b|app control|control it from/i,
      f: /remote|\bapp\b|bluetooth|wi-?fi/i },
    { k: 'adapter', label: 'an adapter or charger',
      q: /adapt[eo]r|charger|power supply|\bsmps\b|\bdriver\b|\bplug\b|charging cable|usb cable/i,
      f: /adapt[eo]r|charger|power supply|\bsmps\b|\bplug\b|cable|\bdriver\b/i },
    { k: 'charge', label: 'charging time or battery life',
      q: /charg(e|ing) time|time to charge|how long.{0,20}(charge|last|run|backup)|battery (life|backup)|backup time|hours? (of )?(backup|battery)/i,
      f: /charg|battery|backup|hours?\b|mah/i },
    { k: 'cut', label: 'whether it can be cut or extended',
      q: /\bcut\b|can i (trim|extend)|extension|extendable|cuttable/i,
      f: /\bcut\b|cuttable|extend|trim/i },
    { k: 'box', label: 'what is in the box',
      q: /in the box|what.{0,12}(do i get|comes? with|is included|are included)|package includes?|what('s| is) included/i,
      f: /box|includes?|included|pack of|set of|\d+\s?(pcs|pieces)/i },
    { k: 'power', label: 'its power type',
      q: /\bpower(ed)?\b|\bbatter(y|ies)\b|\busb\b|rechargeable|voltage|\bvolts?\b|\bwatts?\b|runs? on|how (does|do) it (run|work)|\bcells?\b|\bplug.?in\b/i,
      f: /batter(y|ies)|\busb\b|rechargeable|mah|\b\d+(\.\d+)?\s?v\b|volt|\bwatts?\b|\b\d+\s?w\b|plug.?in|\bAC\b|\bDC\b/i }
  ];
  function pfPlain(html) {
    return String(html || '').replace(/<\s*(br|\/p|\/li|\/div|\/h\d|\/tr|\/ul)[^>]*>/gi, '\n').replace(/<li[^>]*>/gi, '\n')
      .replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&#39;|&rsquo;/g, '’').replace(/[ \t]+/g, ' ');
  }
  function pfSentences(p, re) {
    var parts = pfPlain(p.description).split(/\n+|[.!?]\s+|\s[|•·]\s/), out = [], seen = {};
    parts.forEach(function (x) {
      x = x.replace(/^[\s\-–•*:]+/, '').trim();
      if (x.length < 6 || x.length > 200 || !re.test(x)) return;
      var key = x.toLowerCase().replace(/[^a-z0-9]/g, '');
      if (seen[key] || out.length >= 3) return;
      seen[key] = 1; out.push(x);
    });
    return out;
  }
  function pfFacts(k, c) {
    var o = [];
    if (!c) return o;
    if (k === 'water' && c.ip) o.push('Water protection: <b>' + esc(c.ip) + '</b>');
    if (k === 'adapter' && c.kf && /adapt|driver|power supply|smps|plug|charger/i.test(c.kf)) o.push(esc(c.kf));
    if (k === 'power') {
      if (c.ps) o.push('Power: <b>' + esc(c.ps) + '</b>');
      if (c.volt) o.push('Voltage: <b>' + esc(c.volt) + '</b>');
    }
    return o;
  }
  function askWhichProduct(t) {
    lg('ask_product');
    return say('Which product are you asking about? Type its name (for example “24V COB strip light”) or tap Not sure.').then(function () {
      awaiting = { handle: function (text) {
        var x = text.trim();
        if (/^(cancel|stop|menu|back)$/i.test(x)) return cancelCollect();
        if (/\?$|^(is|does|do|how|what|can|why|when|where|which|who|will)\b/i.test(x) || x.split(/\s+/).length > 8) { awaiting = null; return route(x); }
        return getJSON('/search/suggest.json?q=' + encodeURIComponent(x) + '&resources[type]=product&resources[limit]=3&resources[options][unavailable_products]=last').then(function (j) {
          var list = ((j.resources && j.resources.results && j.resources.results.products) || []).filter(function (y) { return !isHidden(y.handle); }).slice(0, 3);
          if (!list.length) return say('I couldn’t find that product. Try the name as it appears on the site, or tap Not sure.');
          function pick(item) { awaiting = null; lastProd = { handle: item.handle, title: item.title }; return productFactRoute(t); }
          if (list.length === 1) return pick(list[0]);
          return say('Which one do you mean?').then(function () {
            chips(list.map(function (item) { return { label: item.title.length > 38 ? item.title.slice(0, 37) + '…' : item.title, action: function () { return pick(item); } }; })
              .concat([{ label: 'Not sure', action: function () { awaiting = null; return notSure(t); } }]));
          });
        }).catch(function () { awaiting = null; return notSure(t); });
      } };
      chips([{ label: 'Not sure', action: function () { awaiting = null; return notSure(t); } }, { label: 'Cancel', action: cancelCollect }]);
    });
  }
  function notSure(t) {
    var res = scoreAll(t);
    if (res[0] && res[0].s >= 1.0) return disambiguate(res, t);
    return unknown(t, '', 'no match');
  }
  function productFactRoute(t) {
    var cp = curProd(), words = t.split(/\s+/).length;
    if (words > 14) return null;
    if (/price|cost|how much|stock|ship|deliver|return|refund|bulk|warranty|cod\b/i.test(t)) return null;
    var topics = PF.filter(function (x) { return x.q.test(t); });
    if (!topics.length) return null;
    var pron = /\b(it|this|that|these|the product|the light|the lamp|the strip)\b/i.test(t);
    var qshape = /\b(is|are|does|do|can|will|how|what|which|come|comes|included|include|with|need|needs|require|work|works)\b/i.test(t);
    if (/\b(lights|lamps|products|strips|candles|signs)\b/i.test(t) && !pron) return null;
    if (!cp) return (qshape && pron) ? askWhichProduct(t) : null;
    if (!qshape && words > 5) return null;
    return getProduct(cp.handle).then(function (p) {
      cp.title = p.title; if (lastProd && lastProd.handle === cp.handle) lastProd.title = p.title;
      var c = catInfo(cp.handle), found = [], missing = [], usedCat = '', CATF = window.CLCB_CATFACTS || {};
      topics.forEach(function (tp) {
        var facts = pfFacts(tp.k, c), sents = pfSentences(p, tp.f);
        if (facts.length || sents.length) found.push(facts.concat(sents.map(esc)));
        else {
          var cf = CATF[c && c.type] && CATF[c.type][tp.k];
          if (cf) { found.push([esc(cf)]); usedCat = c.type; } else missing.push(tp);
        }
      });
      lg('prodfact_' + topics[0].k);
      var html = '<b>' + esc(p.title) + '</b>';
      found.forEach(function (list) { html += '<br>' + list.map(function (x) { return '• ' + x; }).join('<br>'); });
      if (found.length) html += '<br><small>' + (usedCat ? 'From this product’s details and what is typical for our ' + esc(usedCat) + '.' : 'From this product’s details.') + '</small>';
      if (missing.length) {
        var lbl = missing.map(function (x) { return x.label; }).join(' or ');
        html += (found.length ? '<br><br>' : '<br>') + 'The product details don’t mention ' + esc(lbl) + ', so I won’t guess. Our team can confirm.';
        logQ(t, 'product fact: ' + missing.map(function (x) { return x.k; }).join(','), p.title);
      }
      return say(html).then(function () {
        var cs = [];
        if (missing.length) {
          cs.push({ label: 'Ask on WhatsApp', href: waLink('Hi Chronos, question about ' + p.title + ' (' + location.origin + '/products/' + p.handle + '): ' + t), newTab: true });
          cs.push({ label: 'Request a call back', action: function () { lastQuestion = t; return flows.callback(); } });
        }
        cs.push({ label: 'Choose options & add to cart', action: function () { return startProduct(p.handle); } });
        cs.push({ label: 'Back to menu', action: 'menu' });
        chips(cs);
      });
    }).catch(function () { return unknown(t, '', 'no match'); });
  }

  /* ----- pincode delivery check ----- */
  var PIN_OK = {}; 
  (function () {
    function add(a, b) { for (var i = a; i <= b; i++) PIN_OK[i] = 1; }
    add(11, 14); add(15, 19); add(20, 28); add(30, 34); add(36, 49); add(50, 53); add(56, 59); add(60, 64); add(67, 69); add(70, 79); add(80, 85);
  })();
  function pinRegion(pin) {
    var p2 = Number(pin.slice(0, 2)), p3 = Number(pin.slice(0, 3));
    if (p2 === 18 || p2 === 19) return { name: 'J&K / Ladakh', days: '7–14' };
    if (p2 === 78 || p2 === 79 || p3 === 737) return { name: 'North East', days: '7–14' };
    if ((p2 >= 36 && p2 <= 39) || (p2 >= 40 && p2 <= 44)) return { name: 'West India', days: '3–5' };
    if (p3 === 744 || p3 === 682) return null;
    return { name: 'your area', days: '5–7' };
  }
  function inMumbai(pin) {
    var N = window.CLCB_NOTICE || {}, r = N.mumbaiPins || [['400001', '400104']], n = Number(pin);
    return r.some(function (x) { return n >= Number(x[0]) && n <= Number(x[1]); });
  }
  function mumbaiOnlyNow() {
    var N = window.CLCB_NOTICE; if (!N || !N.shipUntil || !N.shipAfter) return false;
    var d = istDate(); return d > N.shipUntil && (!N.shipEnds || d <= N.shipEnds);
  }
  function pinResult(pin) {
    lg('pincode_check');
    if (!/^[1-9]\d{5}$/.test(pin) || !PIN_OK[Number(pin.slice(0, 2))]) {
      return say('That doesn’t look like a valid Indian pincode. It has 6 digits, for example 400080.').then(function () { return pinAsk(); });
    }
    var rg = pinRegion(pin), mum = inMumbai(pin), html, again = [{ label: 'Check another pincode', action: 'pincode' }];
    if (mumbaiOnlyNow()) {
      if (mum) {
        html = '✅ We can deliver to <b>' + pin + '</b> in Mumbai, using Porter at additional charges. Orders are dispatched within 48 hours.';
      } else {
        logQ('pincode ' + pin + ' not served (Mumbai only)', 'pincode', '');
        html = 'Sorry, we are currently delivering in <b>Mumbai only</b> (using Porter at additional charges), so we can’t deliver to <b>' + pin + '</b> right now.';
        again.unshift({ label: 'Ask our team', href: waLink('Hi Chronos, can you deliver to pincode ' + pin + '? ' + pageContext()), newTab: true });
      }
    } else if (!rg) {
      html = 'I can’t confirm delivery to <b>' + pin + '</b> from here. Our team can check it for you.';
      again.unshift({ label: 'Ask our team', href: waLink('Hi Chronos, can you deliver to pincode ' + pin + '? ' + pageContext()), newTab: true });
    } else {
      html = '✅ We deliver to <b>' + pin + '</b>' + (rg.name !== 'your area' ? ' (' + rg.name + ')' : '') + '. Orders are dispatched within 48 hours, then delivery usually takes <b>' + rg.days + ' working days</b>, depending on the courier.' +
        (mum ? '<br>Same-day delivery in Mumbai is available at additional cost.' : '') + '<br><small>Delivery is free on orders of ₹1,999 or more.</small>';
    }
    return say(html + noticeHtml('delay')).then(function () { chips(again.concat([{ label: 'Back to menu', action: 'menu' }])); });
  }
  function pinAsk() {
    return say('📍 Enter your <b>6-digit pincode</b> and I’ll check delivery.').then(function () {
      awaiting = { handle: function (text) {
        var x = text.trim();
        if (/^(cancel|stop|menu|back)$/i.test(x)) return cancelCollect();
        var m = x.match(/\b[1-9]\d{5}\b/);
        if (!m && (/\?$|^(is|does|do|how|what|can|why|when|where|which|who|will)\b/i.test(x) || x.split(/\s+/).length > 6)) { awaiting = null; return route(x); }
        awaiting = null;
        return pinResult(m ? m[0] : x.replace(/\s+/g, ''));
      } };
      chips([{ label: 'Cancel', action: cancelCollect }]);
    });
  }
  flows.pincode = function () {
    var m = String(lastQuestion || '').match(/\b[1-9]\d{5}\b/);
    return m ? pinResult(m[0]) : pinAsk();
  };

  /* ----- product finder: goal, power, budget -> two or three suggestions ----- */
  var BUDGETS = [
    { label: 'Under ₹500', lo: 0, hi: 500 }, { label: '₹500 – ₹1,500', lo: 500, hi: 1500 },
    { label: '₹1,500 and above', lo: 1500, hi: 1e9 }, { label: 'Any budget', lo: 0, hi: 1e9 }
  ];
  var POWERS = [
    { label: 'Plug into the wall', k: 'p' }, { label: 'USB / power bank', k: 'u' },
    { label: 'Battery or rechargeable', k: 'b' }, { label: 'No preference', k: '' }
  ];
  function finderPick(goal, power, bud) {
    var F = window.CLCB_FINDER, set = {}, items = [];
    goal.h.forEach(function (h) { set[h] = 1; });
    F.items.forEach(function (it) { if (set[it.h] && !isHidden(it.h)) items.push(it); });
    function run(usePower, useBudget) {
      return items.filter(function (it) {
        if (usePower && power.k && it.w.indexOf(power.k) < 0) return false;
        if (useBudget && (it.p < bud.lo || it.p >= bud.hi)) return false;
        return true;
      }).sort(function (a, b) { return b.s - a.s; });
    }
    var tries = [[true, true], [true, false], [false, true], [false, false]], pool = [], relaxed = 0;
    for (var i = 0; i < tries.length; i++) {
      pool = run(tries[i][0], tries[i][1]);
      if (pool.length >= 2) { relaxed = i; break; }
    }
    var out = [], usedT = {};
    pool.forEach(function (it) { if (out.length < 3 && !usedT[it.t]) { usedT[it.t] = 1; out.push(it); } });
    pool.forEach(function (it) { if (out.length < 3 && out.indexOf(it) < 0) out.push(it); });
    return { list: out, relaxed: relaxed };
  }
  flows.finder = function () {
    var F = window.CLCB_FINDER;
    if (!F || !F.goals) return flows.choose();
    lg('finder_start');
    var st = {};
    function budget() {
      return say('What’s your budget?').then(function () {
        chips(BUDGETS.map(function (b) { return { label: b.label, action: function () { st.bud = b; return result(); } }; }));
      });
    }
    function power() {
      if (!st.goal.askPower) return budget();
      return say('How would you like to power it?').then(function () {
        chips(POWERS.map(function (p) { return { label: p.label, action: function () { st.pow = p; return budget(); } }; }));
      });
    }
    function result() {
      var pick = finderPick(st.goal, st.pow || { k: '' }, st.bud);
      if (!pick.list.length) { return say('I couldn’t find a good match. Our team can suggest something.').then(function () { return flows.human(); }); }
      return Promise.all(pick.list.map(function (it) { return getProduct(it.h).catch(function () { return null; }); })).then(function (ps) {
        var cards = ps.filter(function (p) { return p && (p.variants || []).some(function (v) { return v.available; }); }).map(function (p) {
          var vs = p.variants.filter(function (v) { return v.available; });
          var min = vs.reduce(function (m, v) { return Math.min(m, v.price); }, 1e12);
          return { handle: p.handle, title: p.title, price: min, featured_image: p.featured_image };
        });
        if (!cards.length) { return say('Those are out of stock right now. Our team can suggest an alternative.').then(function () { return flows.human(); }); }
        lg('finder_done');
        var note = pick.relaxed ? '<br><small>I widened the budget or power choice a little to find these.</small>' : '';
        return showCards(cards, '✨ Based on what you told me, these are good picks:' + note, [
          { label: 'Start over', action: 'finder' }, { label: 'Talk to a person', action: 'human' }, { label: 'Back to menu', action: 'menu' }
        ]);
      }).catch(function () { return say('I couldn’t load the suggestions just now. Our team can help.').then(function () { return flows.human(); }); });
    }
    return say('🔎 Let’s find the right light. What are you lighting up?').then(function () {
      var cs = F.goals.map(function (g) { return { label: g.label, action: function () { st.goal = g; return power(); } }; });
      cs.push({ label: 'LED strips (DIY)', action: function () {
        return say('For LED strips, the right choice depends on length and voltage. I can work out the power supply for you, or you can browse the strips.').then(function () {
          chips([{ label: 'Driver calculator', action: 'calc_driver' }, { label: 'Browse strip lights', href: '/collections/strip-lights' }, { label: 'Back to menu', action: 'menu' }]);
        });
      } });
      cs.push({ label: 'Back to menu', action: 'menu' });
      chips(cs);
    });
  };

  /* ----- silicone profile kit builder: end caps and metal clips for a given length ----- */
  var KIT = window.CLCB_KIT || { handle: 'silicone-end-caps-metal-clips-for-flexible-silicone-profile', clipSpacingCm: 40, withHolePerPiece: 1, withoutHolePerPiece: 1 };
  function kitDims(text) {
    var t = String(text || '').toLowerCase(), m = t.match(/(\d{1,2})\s*(?:mm)?\s*[x×]\s*(\d{1,2})/);
    var round = /(\d{2})\s*(?:mm)?[^a-z0-9]*(?:360[^a-z0-9]*)?round/.exec(t) || /round[^0-9]{0,12}(\d{2})/.exec(t);
    return { a: m ? Number(m[1]) : 0, b: m ? Number(m[2]) : 0, v: /v.?shape|corner/.test(t), round: round ? Number(round[1]) : 0 };
  }
  function kitSizeMatch(sizes, text) {
    var d = kitDims(text), hit = null;
    if (d.round) { sizes.forEach(function (s) { if (new RegExp('^' + d.round + 'mm round', 'i').test(s)) hit = s; }); return hit; }
    if (!d.a) return null;
    var cands = sizes.filter(function (s) {
      return s.split('/').some(function (part) {
        var k = kitDims(part); return (k.a === d.a && k.b === d.b) || (k.a === d.b && k.b === d.a);
      });
    });
    if (!cands.length) return null;
    var vpref = cands.filter(function (s) { return /v shape/i.test(s) === d.v; });
    return (vpref.length ? vpref : cands)[0];
  }
  function kitNumber(text, lo, hi) {
    var m = String(text).replace(',', '.').match(/\d+(\.\d+)?/), n = m ? parseFloat(m[0]) : NaN;
    return (n >= lo && n <= hi) ? n : null;
  }
  flows.silicone_kit = function () {
    lg('kit_start');
    var st = {};
    function askNum(prompt, lo, hi, hint, opts, next) {
      return say(prompt).then(function () {
        awaiting = { handle: function (text) {
          if (/^(cancel|stop|menu|back)$/i.test(text.trim())) return cancelCollect();
          var n = kitNumber(text, lo, hi);
          if (n === null) return say(hint);
          awaiting = null; return next(n);
        } };
        var cs = (opts || []).map(function (o) { return { label: String(o), action: function () { awaiting = null; return next(o); } }; });
        cs.push({ label: 'Cancel', action: cancelCollect });
        chips(cs);
      });
    }
    function result() {
      var per = st.len / st.pieces;
      var clipsPer = Math.max(2, Math.ceil(per * 100 / (KIT.clipSpacingCm || 40)));
      var need = [
        { re: /with hole/i, not: /without/i, n: st.pieces * (KIT.withHolePerPiece || 1), label: 'End cap with hole (for the power wire)' },
        { re: /without hole/i, n: st.pieces * (KIT.withoutHolePerPiece || 1), label: 'End cap without hole' },
        { re: /clip/i, n: st.pieces * clipsPer, label: 'Metal mounting clip' }
      ];
      var rows = [], ids = [], total = 0, missing = [];
      need.forEach(function (nd) {
        var v = st.acc.variants.filter(function (x) {
          var o1 = x.option1 || '', o2 = x.option2 || '';
          return o1 === st.size && nd.re.test(o2) && !(nd.not && nd.not.test(o2));
        })[0];
        if (!v || !v.available) { missing.push(nd.label); return; }
        total += v.price * nd.n; ids.push(v.id + ':' + nd.n);
        rows.push('• ' + nd.n + ' × ' + esc(nd.label) + ' · ' + money(v.price * nd.n));
      });
      lg('kit_done');
      var h = '🧰 <b>Kit for ' + (Math.round(st.len * 10) / 10) + ' m of profile (' + esc(st.size) + ')</b><br>' + st.pieces + (st.pieces > 1 ? ' pieces' : ' piece') + ', about ' + (Math.round(per * 10) / 10) + ' m each<br><br>' + (rows.join('<br>') || 'Nothing in stock right now.');
      if (missing.length) h += '<br><br><small>Out of stock right now: ' + esc(missing.join(', ')) + '. Our team can suggest an alternative.</small>';
      if (ids.length) h += '<br><br><b>Kit total ' + money(total) + '</b><br><button type="button" class="clcb-mini" data-clcb-upsell="' + esc(ids.join(',')) + '" data-kit="1" data-title="end caps and clips kit">+ Add kit to cart</button>';
      h += '<br><br><small>The profile itself is sold per metre. Choose your length on its product page. You can change quantities in the cart. Silicone end caps use one with a wire hole and one without per piece, and clips are about every ' + (KIT.clipSpacingCm || 40) + ' cm.</small>';
      var pp = PAGE.product && /silicone/i.test((PAGE.product.title || '') + ' ' + (PAGE.product.handle || '')) ? PAGE.product : null;
      return say(h, 400).then(function () {
        var cs = [];
        if (pp) cs.push({ label: 'Back to the profile', href: '/products/' + pp.handle, newTab: false });
        else cs.push({ label: 'Browse silicone profiles', href: '/search?q=silicone%20profile&type=product' });
        cs.push({ label: 'Build another kit', action: 'silicone_kit' }, { label: 'Talk to a person', action: 'human' }, { label: 'Back to menu', action: 'menu' });
        chips(cs);
      });
    }
    function askLength() {
      return askNum('How many <b>metres</b> of silicone profile will you use in total?', 0.5, 500, 'Please enter the length in metres, for example 5 or 12.5.', [], function (len) {
        st.len = len;
        return askNum('How many <b>separate pieces</b> will you cut it into? Each piece needs its own two end caps.', 1, 100, 'Please enter a number, for example 1 or 3.', [1, 2, 3, 4], function (n) {
          st.pieces = Math.max(1, Math.round(n)); return result();
        });
      });
    }
    function askSize(sizes, prefill) {
      var pre = prefill && kitSizeMatch(sizes, prefill);
      if (pre) { st.size = pre; return say('Using the <b>' + esc(pre) + '</b> size.').then(askLength); }
      return say('Which <b>profile size</b> do you have? Type it (for example 16x16) or tap one.').then(function () {
        function pickText(text) {
          if (/^(cancel|stop|menu|back)$/i.test(text.trim())) return cancelCollect();
          var m = kitSizeMatch(sizes, text);
          if (!m) return say('I couldn’t match that size. Please type it like 16x16, or tap one below.');
          awaiting = null; st.size = m; return askLength();
        }
        awaiting = { handle: pickText };
        var cs = sizes.map(function (z) { return { label: z.replace(/ V Shape/i, ' V').slice(0, 30), action: function () { awaiting = null; st.size = z; return askLength(); } }; });
        cs.push({ label: 'Cancel', action: cancelCollect });
        chips(cs);
      });
    }
    return getProduct(KIT.handle).then(function (acc) {
      st.acc = acc;
      var seen = {}, sizes = [];
      (acc.variants || []).forEach(function (v) { if (v.option1 && !seen[v.option1]) { seen[v.option1] = 1; sizes.push(v.option1); } });
      var cp = curProd(), src = (PAGE.product ? PAGE.product.title : '') || (cp && cp.title) || '';
      var onSil = (PAGE.product && /silicone/i.test((PAGE.product.title || '') + ' ' + (PAGE.product.handle || ''))) || false;
      return say('🧰 <b>Silicone profile kit builder</b>. I’ll work out the end caps and metal clips you need.').then(function () {
        return askSize(sizes, onSil ? src : '');
      });
    }).catch(function () { return say('I couldn’t load the kit details just now. Our team can help.').then(function () { return flows.human(); }); });
  };

  /* ----- WhatsApp handoff: short summary of this chat so the team does not ask again ----- */
  function waSummary(already) {
    try {
      var out = [], qs = (SESS.qs || []).filter(function (x) { return x && x.length > 2 && String(already || '').indexOf(x) < 0; }).slice(-4);
      if (qs.length) out.push('Asked in chat: ' + qs.map(function (x) { return '“' + String(x).slice(0, 80) + '”'; }).join('; '));
      var cp = (typeof curProd === 'function') && curProd();
      if (cp && cp.title && !PAGE.product) out.push('Product discussed: ' + cp.title);
      if (lastVerified && lastVerified.order) out.push('Order checked: ' + lastVerified.order);
      if (!out.length) return '';
      return '\n\n— Chat summary —\n' + out.join('\n');
    } catch (e) { return ''; }
  }

  var TRANSACT = [
    [/\bcancel(l?ed|l?ing|lation)?\b/i, 'cancel_order'],
    [/\bpin ?code\b|\bpin code\b|serviceab|^\s*[1-9]\d{5}\s*$|(deliver|ship|available|reach)\w*.{0,40}\b[1-9]\d{5}\b|\b[1-9]\d{5}\b.{0,40}(deliver|ship|available)/i, 'pincode'],
    [/\b(send|share|need|want|get|download|resend|mail|email)\b.{0,25}\b(invoice|bill)\b|\b(invoice|bill)\b.{0,30}(my order|not received|didn.?t get|haven.?t (got|received)|missing)/i, 'invoice'],
    [/\bhelp me (choose|pick|select|find|decide)\b|\b(recommend|suggest)\b.{0,30}\b(light|lamp|product|something)s?\b|\bwhat (light|lamp)s? (should|to) (i )?(buy|get|choose)\b|\bgift ideas?\b|\bwhich (light|lamp)s?\b.{0,20}\b(best|buy|should)\b|\bproduct finder\b/i, 'finder'],
    [/\bend ?caps?\b|\b(metal|mounting) clips?\b|\bclips?\b.{0,20}(profile|silicone)|\bsilicone\b.{0,25}\b(kit|accessor)|\bkit builder\b|how many (clips|caps)/i, 'silicone_kit'],
    [/\brefunds?\b|money back|reimburse|paise? wapas|paisa wapas/i, 'refund'],
    [/which driver|what driver|driver (size|do i need|should i|for my)|how many watts|wattage|power supply for|adapter for|driver calculator|calculate.*(driver|watt)/i, 'calc_driver'],
    [/top.?up|reach free/i, 'topup'],
    [/\btrack(ing)?\b|order status|where is my (order|parcel|package)|status of (my )?order/i, 'order'],
    [/\bcart\b|basket|checkout/i, 'cart'],
    [/\b(offers?|discounts?|coupons?|deals?|diwali sale|sale)\b/i, 'offers'],
    [/\b(talk|speak) to (a |an )?(human|person|agent|someone|team)|\bhuman\b|\bagent\b|call me|call ?back|\bcallback\b/i, 'human']
  ];
  var LEGACY = [
    [/neon sign|custom neon|gen ?1|gen ?2/i, 'neon'],
    [/bulk|wholesale|corporate|b2b|dealer/i, 'bulk'],
    [/\breturns?\b|refund|replacement|exchange/i, 'returns'],
    [/\bship|deliver|courier|dispatch/i, 'shipping'],
    [/track|order status|where is my order/i, 'order'],
    [/phone|e-?mail|contact|address|timing/i, 'contact']
  ];

  function disambiguate(list, q) {
    return say('I found a few things that might match. Which one do you mean?').then(function () {
      var seen = {}, cs = [];
      list.forEach(function (x) {
        if (seen[x.e.topic] || cs.length >= 3) return;
        seen[x.e.topic] = 1;
        var label = x.e.topic.length > 34 ? x.e.topic.slice(0, 33) + '…' : x.e.topic;
        cs.push({ label: label, action: function () { return answerEntry(x.e, q); } });
      });
      cs.push({ label: 'None of these', action: function () { return unknown(q, '', 'no match'); } });
      chips(cs);
    });
  }

  function looksLikeProductQuery(text) {
    var t = tok(text);
    return t.length > 0 && t.length <= 7 && text.trim().length >= 3;
  }

  function route(text) {
    var t = text.trim(), i;
    lastQuestion = t;
    if (/^(hi+|hello+|hey+|namaste|good (morning|afternoon|evening))\b[\s!.]*$/i.test(t)) return run('menu');
    if (/^(thanks?|thank you|thx|ok(ay)?|great|cool|got it|bye)\b[\s!.]*$/i.test(t)) {
      return say('You’re welcome! Anything else I can help with?').then(function () { chips(MENU); });
    }
    for (i = 0; i < TRANSACT.length; i++) {
      if (TRANSACT[i][0].test(t)) return run(TRANSACT[i][1]);
    }
    if (lastProd && !PAGE.product && /\b(it|this one|that one)\b/i.test(t) && /price|cost|how much|stock|available|buy|add to cart|order/i.test(t)) return startProduct(lastProd.handle);
    var _pf = productFactRoute(t); if (_pf) return _pf;
    if (PAGE.product && /price|cost|how much|in stock|stock|available|availability/i.test(t) && !/bulk|wholesale|moq|per meter|per metre/i.test(t)) {
      return run('product_price');
    }
    if (/\b(store|shop|showroom|outlet)\b.*\b(where|address|location|visit|located|timing)|\b(where|address|location|visit)\b.*\b(store|shop|showroom|outlet)\b|\bpick.?up\b.*\b(store|shop)\b|\bmulund\b|\bwalk.?in\b/i.test(t) && !/order|track|deliver|ship/i.test(t)) {
      var _st = (KB.entries || []).filter(function (x) { return x.id === 'KB068' && x.a; })[0];
      if (_st) return answerEntry(_st, t);
    }
    if (/\b(cod|cash on delivery)\b/i.test(t) && !/neon|refund|bulk|return|cancel/i.test(t)) {
      var _cd = (KB.entries || []).filter(function (x) { return x.id === 'KB017' && x.a; })[0];
      if (_cd) return answerEntry(_cd, t);
    }
    if (/wrong (item|product)|different (item|product) (received|delivered)|(received|got) (a )?wrong/i.test(t)) return run('claim');
    var _dm = [[/\bemi\b|instal+ments?|no.?cost emi/i, 'KB085'], [/reseller|resell\b|dropship|drop.ship|franchise|distributor/i, 'KB087']];
    for (var _k = 0; _k < _dm.length; _k++) {
      if (_dm[_k][0].test(t)) { var _de = (KB.entries || []).filter(function (x) { return x.id === _dm[_k][1] && x.a; })[0]; if (_de) return answerEntry(_de, t); }
    }
    if (/(not|n.t|never)\s*(yet\s*)?(received|delivered|arrived)|haven.?t (received|got)|didn.?t (receive|get)/i.test(t)) return run('order');
    var res = scoreAll(t);
    var best = res[0], second = res[1];
    var close = res.filter(function (x) { return x.s >= best.s * 0.7 && x.e.topic !== best.e.topic; });
    if (best && best.s >= 1.0 && !close.length) return answerEntry(best.e, t);
    if (best && best.s >= 1.0 && second && best.s >= second.s * 1.35 && best.s >= 2.2) return answerEntry(best.e, t);
    if (best && best.s >= 1.0) return disambiguate(res, t);
    for (i = 0; i < LEGACY.length; i++) {
      if (LEGACY[i][0].test(t)) return run(LEGACY[i][1]);
    }
    if (looksLikeProductQuery(t)) return searchProducts(t);
    return unknown(t, '', 'no match');
  }

  function handleText(text) {
    if (awaiting) return awaiting.handle(text);
    if (awaitQty) {
      if (/^(cancel|back|menu|no)$/i.test(text.trim())) { awaitQty = null; return run('menu'); }
      var n = parseInt(text.replace(/\D/g, ''), 10);
      if (n > 0 && n <= 999) {
        var a = awaitQty; awaitQty = null;
        return addToCart(a.p, a.v, n, false);
      }
      return say('Please type a number, for example 3 (or type "cancel").');
    }
    return loadKB().then(function () { return route(text); });
  }

  /* ---------- open / close ---------- */
  var started = false;
  function open() {
    win.classList.add('is-open');
    badge.style.display = 'none';
    launcher.setAttribute('aria-label', 'Close chat');
    safe(function () { sessionStorage.setItem('clcb_open', '1'); });
    if (!started) {
      started = true;
      loadKB();
      var g = greeting();
      botSay(g.text + (typeof noticeHtml === 'function' ? noticeHtml('all') : '') + '<br><small style="opacity:.7">To improve our service, we record what you ask here (phone numbers and emails are removed) and what you tap. Please don’t type personal details in the chat; use the forms I offer. <a href="' + esc(PRIVACY) + '" target="_blank" rel="noopener" style="color:#D9A521">Privacy Policy</a></small>', 350).then(function () { var cs = (g.chips || []).filter(Boolean); if (g.chips !== MENU) cs = cs.concat([{ label: '☰ Menu', action: 'menu' }]); chips(cs); });
    }
    setTimeout(function () { input.focus(); }, 50);
  }
  function close() {
    win.classList.remove('is-open');
    launcher.setAttribute('aria-label', 'Open chat');
    safe(function () { sessionStorage.removeItem('clcb_open'); });
  }

  launcher.addEventListener('click', function () {
    win.classList.contains('is-open') ? close() : open();
  });
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && win.classList.contains('is-open')) close();
  });
  footer.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = input.value.trim();
    if (!v) return;
    input.value = '';
    userSay(v);
    handleText(v);
  });


  /* ---------- gentle cart-page nudge (once per session, dismissible) ---------- */
  (function () {
    if (CFG.proactiveCart === false || PAGE.template !== 'cart') return;
    if (safe(function () { return sessionStorage.getItem('clcb_nudged'); })) return;
    var timer = setTimeout(function () {
      if (win.classList.contains('is-open')) return;
      getCart().then(function (cart) {
        if (!cart || !cart.item_count || cart.total_price >= THRESH) return;
        if (win.classList.contains('is-open')) return;
        var left = Math.ceil((THRESH - cart.total_price) / 100);
        var n = el('div', 'clcb-nudge');
        n.innerHTML = '<button type="button" class="clcb-nudge-x" aria-label="Dismiss">&times;</button>' +
          '<div>You’re <b>₹' + left.toLocaleString('en-IN') + '</b> away from free delivery 🚚</div>' +
          '<button type="button" class="clcb-nudge-go">Show me easy add-ons</button>';
        root.appendChild(n);
        safe(function () { sessionStorage.setItem('clcb_nudged', '1'); });
        lg('nudge_shown');
        n.querySelector('.clcb-nudge-x').addEventListener('click', function () { n.remove(); });
        n.querySelector('.clcb-nudge-go').addEventListener('click', function () {
          n.remove(); lg('nudge_clicked');
          if (!win.classList.contains('is-open')) open();
          setTimeout(function () { run('topup'); }, 700);
        });
        setTimeout(function () { if (n.parentNode) n.remove(); }, 20000);
      });
    }, CFG.nudgeDelay || 25000);
    launcher.addEventListener('click', function () { clearTimeout(timer); });
  })();

  /* expose for later stages */
  window.CL = { kb: KB, flows: flows, run: run, botSay: botSay, chips: chips, userSay: userSay, handleText: handleText, config: CFG };
})();